import React from 'react';
import _ from 'lodash';
import Joi from 'joi-browser';
import InsuranceInfoApi from '../../../services/workers/insuranceInfo/InsuranceInfoApi';
import InsuranceInfoService from '../../../services/workers/insuranceInfo/InsuranceInfoService';
import { CcusMasterService } from '../../../services/CcusMasters';
import StaticFileService from '../../../services/StaticFiles';
import SessionStorageService from '../../../services/utilities/SessionStorageService';

import { WorkerHeader } from '../header/WorkerHeader';
import InsuranceInfoForm from '../form/InsuranceInfoForm';
import Information from '../../modals/common/Information';
import Confirmation from '../../modals/common/Confirmation';
import ConfirmationSafetyDocItemDialog from '../dialog/ConfirmationSafetyDocItemDialog';
import { FormInformationDialog } from '../../FormInformationDialog';
import {
  AttentionBox,
  showFixedDataAnnouncementDialog,
  showUserFixApprovalDialog,
} from '../../UserFixDataAttentionComponents';
import { FetchCcusDescription } from '../../FetchCcusDescription';

import masterSlideLoader from '../../../utilities/masterSlideLoader';
import { messageUtility } from '../../../utilities/messageUtility';
import { validationByJoi } from '../../../utilities/commonValidation';
import {
  extractErrorMessage,
  getZendeskArticleUrl,
} from '../../../utilities/commonUtil';
import dialogLoader from '../../../utilities/dialogLoader';
import { isDayBeforeXYearsOld } from '../../../utilities/momentUtil';
import {
  deleteControlCode,
  isNullOrUndefinedOrEmptyStr,
} from '../../../utilities/stringUtil';
import {
  attachDocumentDeleteState,
  attachDocumentWorkerCodesRead,
  attachDocumentWorkerUploadState,
  attachDocumentWorkerDownload,
  attachDocumentFilesCheck,
} from '../../../utilities/attachDocumentUtil';
import { convertDate } from '../../../utilities/validateDateUtil';
import {
  filterComboBoxHealthInsuranceTypeWhenExist,
  filterComboBoxHealthInsuranceTypeWhenExclusion,
  filterComboBoxPensionTypeWhenExist,
  filterComboBoxPensionTypeWhenExclusion,
} from '../../../utilities/insuranceFormUtil';
import PrintUtility from '../../../utilities/printUtility';
import EventMg, { EventType } from '../../../utilities/EventManager';

import {
  ENV_VARS,
  WORKER_TAB,
  WORKER_PAGE_STATUS,
  DIALOG_STATUS,
  DISPLAY_FLAG,
  SAFETY_DOC_ITEM_VALIDATE,
  EXISTANCE_EXCLUSION_FLAG,
  PENSION_VOLUNTARY_COVERAGE_FLAG,
  INSURANCE_RECEIVING_FLAG,
  ATTACH_DOCUMENT_TYPE_WORKER,
  FILE_CODE,
  WORKER_INSURANCE_MANUAL,
  ZENDESK_LINK_IDS,
  ZENDESK_URL_GUIDE,
} from '../../../utilities/constants';

import styles from '../../../styles/componentStyle/workerForm/workerForm.scss';
import { MoveLeftIcon } from '../../icons/MoveLeftIcon';

export const specialReasonComboBoxList = [
  // BLDE_V2-33621により「なし」選択肢を外す TODO: 検討で利用しないようになった場合は削除する
  // {
  //   special_reason_code: '1',
  //   special_reason: 'なし',
  // },
  {
    special_reason_code: '2',
    special_reason: '現場入場時点で６０歳以上で厚生年金保険に未加入',
  },
  {
    special_reason_code: '3',
    special_reason: '工事の施工に必要な特殊技能者',
  },
  {
    special_reason_code: '4',
    special_reason: '加入手続き中(確実に加入見込みあり)',
  },
];

/**
 * 保険加入状況ページ
 * @props {string}companyId:会社ID
 * @props {string}workerId:作業員ID
 * @props {object}pageStatus:ページ情報 (新規・詳細・編集)
 * @props {Boolean}isAlreadyCcusConnect:CCUSと連携しているか？
 * @props {Boolean}isAgencyRegister:代理ログインか？
 * @props {string}linkedToCcusDate:CCUSと連携した時間
 * @props {function}callFetchCcusWorkersData:CCUS情報取得処理
 */
export class InsuranceInfo extends React.Component {
  /* eslint-disable no-multi-spaces */
  defaultInsuranceInfo = {
    // 健康保険
    health_insurance_flag: null, // 加入状況
    health_insurance_special_reason: null, // 特段の理由
    health_insurance_reason_exclusion: null, // 適用除外理由
    health_insurance_type: null, // 健康保険種類
    health_insurance_type_code: null, // 健康保険種類(コード)
    health_insurance_name_insurer: null, // 健康保険者名称
    health_insurance_expiration_date: null, // 満了年月日
    health_insurance_reason_exclusion_other: null,

    // 年金
    pension_flag: null, // 加入状況
    pension_reason_exclusion: null, // 適用除外理由
    pension_voluntary_coverage_flag: null, // 任意加入
    pension_type: null, // 年金種類名称
    pension_type_code: null, // 年金種類名称(コード)
    pension_insurance_expiration_date: null, // 満了年月日
    pension_insurance_receiving_flag: null, // 受給状況

    // 雇用保険
    employment_insurance_flag: null, // 加入状況
    employment_insurance_reason_exclusion: null, // 適用除外理由
    employment_insurance_type: null, // 被保険者種類名称
    employment_insurance_type_code: null, // 被保険者種類名称(コード)
    employment_insurance_insured_number: null, // 被保険者番号

    // その他伝達事項など
    memo: '', // メモ

    // 退職金共済
    const_subscription_flag: '0', // 建退共加入状況
    const_number: null, // 建退共被共済者番号
    enterprise_subscription_flag: '0', // 中退共加入状況
    enterprise_agreement_number: null, // 中退共契約者番号
    enterprise_insured_number: null, // 中退共被共済者番号
    other_subscription_flag: '0', // その他退職金共済制度加入状況
    other_subscription_name: null, // その他退職金共済制度名称

    // 労災保険特別加入
    worker_compensation_flag: null, // 加入状況
    worker_compensation_type: null, // 労災保険種類
  };

  state = {
    header: {
      // 作業員基本情報ヘッダー用プロパティ
      LinkButtonObject: {}, // 作業員一覧ページに戻るリンク (内容はbuttonObject)
      buttonObject: {}, // ボタン内容 (内容はbuttonObject)
    },
    headerButtonObject: {
      // ヘッダーで必要なモデル (詳細はWorkerHeader.jsxを参照)
      label: data.defaultButton.label, // テキスト
      className: data.defaultButton.className, // クラス名
      onClick: null, // 処理
    },
    dialogStatus: DIALOG_STATUS.disabled.id, // ダイアログ表示用ステータス
    confirmationModalSafetyDocItem: {
      // 安全書類項目用バリデート
      errorPropertyList: [],
    },
    informationModal: {
      // インフォメーションモーダル用プロパティ (ボタン1つ)
      message: null, // モーダルダイアログのメッセージ
    },
    validErrorMessage: {}, // バリデーションエラーメッセージ
    insuranceInfo: { ...this.defaultInsuranceInfo }, // 保険加入情報格納オブジェクト
    ccus_info: {}, // CCUSから取得した情報を格納する
    comboBoxList: {
      healthInsuranceReasonExclusion: {}, // 保険適用除外理由
      healthInsuranceType: {}, // 健康保険種類
      specialReason: specialReasonComboBoxList, // 健康保険特段の理由
      pensionReasonExclusion: {}, // 年金適用除外理由
      pensionType: {}, // 年金種類名称
      employmentInsuranceReasonExclusion: {}, // 雇用保険適用除外理由
      employmentInsuranceType: {}, // 雇用保険名称
    },
    filteredComboBoxList: {
      healthInsuranceReasonExclusion: {}, // 保険適用除外理由
      healthInsuranceType: {}, // 健康保険種類
      specialReason: specialReasonComboBoxList, // 健康保険特段の理由
      pensionReasonExclusion: {}, // 年金適用除外理由
      pensionType: {}, // 年金種類名称
      employmentInsuranceReasonExclusion: {}, // 雇用保険適用除外理由
      employmentInsuranceType: {}, // 雇用保険名称
    },

    attachDocumentCodes_HealthInsurance: [], // 健康保険 保険証 選択項目
    attachDocuments_HealthInsurance: [], // 健康保険 保険証 内容
    attachDocumentCodes_Pension: [], // 年金 保険証 選択項目
    attachDocuments_Pension: [], // 年金 保険証 内容
    attachDocumentCodes_EmploymentInsurance: [], // 雇用保険 保険証 選択項目
    attachDocuments_EmploymentInsurance: [], // 雇用保険 保険証 内容
    attachDocumentCodes_UnemploymentInsurance: [], // 退職金共済 保険証 選択項目
    attachDocuments_UnemploymentInsurance: [], // 退職金共済 保険証 内容
    attachDocumentCodes_WorkerCompensation: [], // 労災保険特別加入 保険証 選択項目
    attachDocuments_WorkerCompensation: [], // 労災保険特別加入 保険証 内容
    visibleDownloadErrorDialog: false,
    requestUserFixListByHealthInsurance: [],
    requestUserFixListByPensionInsurance: [],
    requestUserFixListByEmploymentInsurance: [],
    userFixApproval: false,
    initialLoadingSocialInsuranceFlag: {
      // 編集画面読み込み時の各種健康保険の加入状況。既存データ対応のための青枠の文字出力のため使用
      healthInsuranceFlag: '',
      pensionFlag: '',
      employmentInsuranceFlag: '',
    },
    roanToChoseiFlg: false, // 労安からの遷移先が直接「作業員詳細」か、黒メニュー「作業員一覧」経由かを区別するフラグ

    isShowPensionExpirationDate: false, // 年金 有効期限項目の表示
    isShowPensionVoluntaryCoverageFlag: false, // 年金 任意加入の表示
  };
  /* eslint-enable no-multi-spaces */
  /* eslint-enable prettier/prettier */

  events = {};

  constructor(props) {
    super(props);
    this.updatingFlag = true; // 多重更新防止Flag

    if (
      !(
        props.pageStatus === WORKER_PAGE_STATUS.CONFIRM ||
        props.pageStatus === WORKER_PAGE_STATUS.EDIT
      )
    ) {
      throw new Error('InsuranceInfo.jsx constructor props.pageStatus');
    }
    if (_.isUndefined(props.workerId)) {
      throw new Error('InsuranceInfo.jsx constructor props.workerId');
    }
    if (_.isUndefined(props.companyId)) {
      throw new Error('InsuranceInfo.jsx constructor props.companyId');
    }

    // InsuranceInfoForm.jsxに渡すイベント
    this.events.validate = this.validate.bind(this);
    this.events.setValueInsuranceInfo = this.setValueInsuranceInfo.bind(this);
    this.events.setCCUSValuesInsurance = this.setCCUSValuesInsurance.bind(this);
    this.events.inputValueSearch = this.inputValueSearch.bind(this);
    this.events.uploadFile = this.uploadFile.bind(this);
    this.events.download = this.download.bind(this);
    this.events.deleteFile = this.deleteFile.bind(this);
    this.events.showCcusInfoTranscriptionAgreementDialog = this.showCcusInfoTranscriptionAgreementDialog.bind(
      this
    );

    this.setInsuranceInfo = this.setInsuranceInfo.bind(this);
    this.state.roanToChoseiFlg = props.roanToChoseiFlg;

    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.CONFIRM.ID:
        this.state = this.createObjectForMoveToWorkerList(this.state);
        this.state = this.createConfirmPageHeaderButton(this.state);
        break;
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.state = this.createObjectForMoveToWorkerList(this.state);
        this.state = this.createEditPageHeaderButton(this.state);
        break;
      default:
        break;
    }

    this.validationColumns = [
      'health_insurance_flag',
      'health_insurance_type',
      'health_insurance_name_insurer',
      'health_insurance_reason_exclusion',
      'health_insurance_reason_exclusion_other',
      'health_insurance_special_reason',
      'health_insurance_expected_date_of_entry',
      'health_insurance_expiration_date',
      'pension_flag',
      'pension_insurance_expiration_date',
      'pension_special_reason',
      'pension_voluntary_coverage_flag',
      'pension_expected_date_of_entry',
      'employment_insurance_flag',
      'employment_insurance_special_reason',
      'employment_insurance_insured_number',
      'employment_insurance_expiration_date',
      'employment_insurance_expected_date_of_entry',
      'const_number',
      'enterprise_agreement_number',
      'enterprise_insured_number',
      'health_insurance_special_reason_other',
      'pension_special_reason_other',
    ];
  }

  /**
   * React Component LifeCycle
   * マウントが行われた直後
   * */
  async componentDidMount() {
    const state = _.cloneDeep(this.state);

    // 労務安全項目情報（保険加入状況）を取得する
    await InsuranceInfoApi.fetchInsuranceInfo(
      this.props.companyId,
      this.props.workerId
    ).then(response => {
      if (response.result) {
        state.ccus_info = response.data.entities.ccus_worker_insurances;

        // NOTE：BLDE_V2-25624 対応で下記項目はCCUS転記を行わないことになったため除外
        // 雇用保険_雇用保険被保険者番号: employment_insurance_insured_number
        // 建設業退職金共済制度_被共済者番号: const_number
        // 中小企業退職金共済制度_被共済者番号: enterprise_insured_number
        state.ccus_info.employment_insurance_insured_number = null;
        state.ccus_info.const_number = null;
        state.ccus_info.enterprise_insured_number = null;

        state.ccus_info.other_subscription_flag = null;
        state.ccus_info.other_subscription_name = null;

        state.insuranceInfo = response.data.entities.worker_insurances;

        // 建退共、中退共、その他退職金共済制度の加入フラグはデフォルトで「無」のため「有」以外（nullや空文字含む）の場合には'0'を設定する
        if (state.insuranceInfo.const_subscription_flag !== '1') {
          state.insuranceInfo.const_subscription_flag = '0';
        }
        if (state.insuranceInfo.enterprise_subscription_flag !== '1') {
          state.insuranceInfo.enterprise_subscription_flag = '0';
        }
        if (state.insuranceInfo.other_subscription_flag !== '1') {
          state.insuranceInfo.other_subscription_flag = '0';
        }
        if (state.insuranceInfo.other_subscription_name === null) {
          state.insuranceInfo.other_subscription_name = '';
        }

        if (!_.isArray(response.data.entities.worker_documents)) {
          throw new Error(
            'InsuranceInfo.jsx componentDidMount worker_documents'
          );
        }
        state.attachDocuments_HealthInsurance = response.data.entities.worker_documents.filter(
          document =>
            document.file_typeL === ATTACH_DOCUMENT_TYPE_WORKER.HEALTH_INSURANCE
        );
        state.attachDocuments_Pension = response.data.entities.worker_documents.filter(
          document =>
            document.file_typeL ===
            ATTACH_DOCUMENT_TYPE_WORKER.PENSION_INSURANCE
        );
        state.attachDocuments_EmploymentInsurance = response.data.entities.worker_documents.filter(
          document =>
            document.file_typeL ===
            ATTACH_DOCUMENT_TYPE_WORKER.EMPLOYMENT_INSURANCE
        );
        state.attachDocuments_UnemploymentInsurance = response.data.entities.worker_documents.filter(
          document =>
            document.file_typeL ===
            ATTACH_DOCUMENT_TYPE_WORKER.RETIREMENT_MUTUAL_AID
        );
        state.attachDocuments_WorkerCompensation = response.data.entities.worker_documents.filter(
          document =>
            document.file_typeL ===
            ATTACH_DOCUMENT_TYPE_WORKER.LABOR_ACCIDENT_INSURANCE_SPECIAL_ENROLLMENT
        );
      } else {
        alert(response.message);
      }
    });

    // comboBoxの中身を取得する
    if (this.props.pageStatus.ID === WORKER_PAGE_STATUS.EDIT.ID) {
      const params = { display_flag: DISPLAY_FLAG.use.id };

      await Promise.all([
        CcusMasterService.healthInsuranceReasonExclusion(params), // 健康保険適用除外理由取得
        CcusMasterService.healthInsuranceType(params), // 健康保険種類取得
        CcusMasterService.pensionReasonExclusion(params), // 年金適用除外理由取得
        CcusMasterService.pensionType(params), // 年金種類名称取得
        CcusMasterService.employmentInsuranceReasonExclusion(params), // 雇用保険適用除外理由取得
        CcusMasterService.employmentInsuranceType(params), // 雇用保険名称
      ]).then(responses => {
        if (_.some(responses, response => response.result === false)) {
          return;
        }
        const [
          health_ins_reasons,
          health_ins_types,
          pension_ins_reasons,
          pension_ins_types,
          employment_ins_reasons,
          employment_ins_types,
        ] = responses;
        state.comboBoxList.healthInsuranceReasonExclusion =
          health_ins_reasons.data.entities.health_ins_reasons;
        state.comboBoxList.healthInsuranceType =
          health_ins_types.data.entities.health_ins_types;
        state.comboBoxList.pensionReasonExclusion =
          pension_ins_reasons.data.entities.pension_ins_reasons;
        state.comboBoxList.pensionType =
          pension_ins_types.data.entities.pension_ins_types;
        state.comboBoxList.employmentInsuranceReasonExclusion =
          employment_ins_reasons.data.entities.employment_ins_reasons;
        state.comboBoxList.employmentInsuranceType =
          employment_ins_types.data.entities.employment_ins_types;

        const newValueCCUSInfo = this.convertCCUSInfoByComboBoxList(state.ccus_info, state.comboBoxList);
        state.ccus_info = { ...state.ccus_info, ...newValueCCUSInfo };

        // 健康保険情報 加入状況が未設定の場合初期値設定する
        // （現在対象外のためコメントアウトで残す）
        // _.map(state.insuranceInfo, (value, key) => {
        //   state.insuranceInfo = this.setDefaultFormValues(
        //     key,
        //     value,
        //     state.insuranceInfo
        //   );
        // });

        state.insuranceInfo = this.setDefaultDropdowns(
          state.comboBoxList,
          state.insuranceInfo
        );

        const noticeData = this.checkExistData(state.insuranceInfo);
        if (
          noticeData['healthInsurance'].length === 0 &&
          noticeData['pensionInsurance'].length === 0 &&
          noticeData['employmentInsurance'].length === 0
        ) {
          state.userFixApproval = true; // 想定外の組み合わせデータがないため通常の更新フローにする
        }
        // state.requestUserFixList = noticeData;
        state.requestUserFixListByHealthInsurance =
          noticeData['healthInsurance'];
        state.requestUserFixListByPensionInsurance =
          noticeData['pensionInsurance'];
        state.requestUserFixListByEmploymentInsurance =
          noticeData['employmentInsurance'];

        state.initialLoadingSocialInsuranceFlag = {
          healthInsuranceFlag: state.insuranceInfo.health_insurance_flag,
          pensionFlag: state.insuranceInfo.pension_flag,
          employmentInsuranceFlag:
            state.insuranceInfo.employment_insurance_flag,
        };
      });
    }

    // 添付ファイル情報 選択項目の小分類コード一覧を取得する
    await attachDocumentWorkerCodesRead(
      state,
      [
        'attachDocumentCodes_HealthInsurance',
        'attachDocumentCodes_Pension',
        'attachDocumentCodes_EmploymentInsurance',
        'attachDocumentCodes_UnemploymentInsurance',
        'attachDocumentCodes_WorkerCompensation',
      ],
      [
        ATTACH_DOCUMENT_TYPE_WORKER.HEALTH_INSURANCE,
        ATTACH_DOCUMENT_TYPE_WORKER.PENSION_INSURANCE,
        ATTACH_DOCUMENT_TYPE_WORKER.EMPLOYMENT_INSURANCE,
        ATTACH_DOCUMENT_TYPE_WORKER.RETIREMENT_MUTUAL_AID,
        ATTACH_DOCUMENT_TYPE_WORKER.LABOR_ACCIDENT_INSURANCE_SPECIAL_ENROLLMENT,
      ]
    );

    // CCUSから情報を取得ボタンを押された後の処理
    if (this.props.pageStatus.ID === WORKER_PAGE_STATUS.EDIT.ID) {
      EventMg.addEventListener(EventType.FETCH_CCUS_INFO, async () => {
        // CCUS情報の再取得
        await InsuranceInfoApi.fetchInsuranceInfo(
          this.props.companyId,
          this.props.workerId
        ).then(response => {
          if (response.result) {
            const state = _.cloneDeep(this.state);
            state.ccus_info = response.data.entities.ccus_worker_insurances;

            // NOTE：BLDE_V2-25624 対応で下記項目はCCUS転記を行わないことになったため除外
            // 雇用保険_雇用保険被保険者番号: employment_insurance_insured_number
            // 建設業退職金共済制度_被共済者番号: const_number
            // 中小企業退職金共済制度_被共済者番号: enterprise_insured_number
            state.ccus_info.employment_insurance_insured_number = null;
            state.ccus_info.const_number = null;
            state.ccus_info.enterprise_insured_number = null;

            state.ccus_info.other_subscription_flag = null;
            state.ccus_info.other_subscription_name = null;

            const newValueCCUSInfo = this.convertCCUSInfoByComboBoxList(state.ccus_info, state.comboBoxList);
            state.ccus_info = { ...state.ccus_info, ...newValueCCUSInfo };

            this.setState(state);
          }
        });
      });
    }

    this.setState(state, () => {
      this.updatingFlag = false; // 画面ロード後更新可能になる
      if (this.hasRequestUserFixList()) {
        showFixedDataAnnouncementDialog(
          state.requestUserFixListByHealthInsurance,
          state.requestUserFixListByPensionInsurance,
          state.requestUserFixListByEmploymentInsurance
        );
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    // 作業員の年齢が親コンポーネント(WorkerForm)から取得された後に初期表示プルダウンロジックを実行する（編集画面のみ）
    if (
      !prevProps.workerBirthday &&
      this.props.workerBirthday &&
      this.props.pageStatus.ID === WORKER_PAGE_STATUS.EDIT.ID
    ) {
      let insuranceInfo = _.cloneDeep(this.state.insuranceInfo);
      insuranceInfo = this.setFormItemOtherState(
        this.state.comboBoxList,
        this.state.insuranceInfo
      );
      this.setState({ insuranceInfo });
    }
    if (
      this.props.workerBirthday !== prevProps.workerBirthday ||
      !_.isEqual(this.state.insuranceInfo, prevState.insuranceInfo) ||
      this.state.isShowPensionVoluntaryCoverageFlag !==
        prevState.isShowPensionVoluntaryCoverageFlag
    ) {
      if (this.state.insuranceInfo.pension_insurance_receiving_flag) {
        this.showPensionVoluntaryCoverageFlag();
      }
      this.updateComboBoxList();
      this.showPensionExpirationDate();
    }
  }

  convertCCUSInfoByComboBoxList = (ccus_info, comboBoxList) => {
    const result = {};
    if (!isNullOrUndefinedOrEmptyStr(ccus_info.health_insurance_type)) {
      const targetValue = _.find(
        comboBoxList.healthInsuranceType,
        healthInsuranceType => {
          return _.includes(
            [healthInsuranceType.health_insurance_type_code, healthInsuranceType.health_insurance_type],
            ccus_info.health_insurance_type,
          );
        },
      );
      if (!_.isUndefined(targetValue)) {
        result.health_insurance_type =
          targetValue.health_insurance_type;
      } else {
        result.health_insurance_type = null;
      }
    }

    if (!isNullOrUndefinedOrEmptyStr(ccus_info.pension_type)) {
      const targetValue = _.find(
        comboBoxList.pensionType,
        pensionType => {
          return _.includes(
            [pensionType.pension_type_code, pensionType.pension_type], ccus_info.pension_type,
          );
        },
      );
      if (!_.isUndefined(targetValue)) {
        result.pension_type = targetValue.pension_type;
      } else {
        result.pension_type = null;
      }
    }

    // state.ccus_info.employment_insurance_type には
    // APIから取得された値が入り、
    // "1" などの Combobox内のコード値
    // もしくは "一般" などの文字列になってここの処理に至る
    // Comboboxに一致する場合は、"1"を"一般"に変換するので
    // "一般"などの任意の文字列が送られた場合にも対応する処理になっている
    if (!isNullOrUndefinedOrEmptyStr(ccus_info.employment_insurance_type)) {
      const targetValue = _.find(
        comboBoxList.employmentInsuranceType,
        employmentInsuranceType => {
          return _.includes(
            [employmentInsuranceType.employment_insurance_type_code, employmentInsuranceType.employment_insurance_type],
            ccus_info.employment_insurance_type,
          );
        },
      );
      if (!_.isUndefined(targetValue)) {
        result.employment_insurance_type =
          targetValue.employment_insurance_type;
      } else {
        result.employment_insurance_type = null;
      }
    }
    return result;
  };

  // 保険種類などのプルダウンで可能な選択項目をフォームのデータによって反映する
  updateComboBoxList = () => {
    const {
      comboBoxList,
      insuranceInfo,
      isShowPensionVoluntaryCoverageFlag,
    } = this.state;

    // APIから取得されてない場合はreturn
    if (!insuranceInfo || !this.props.workerBirthday) {
      return;
    }

    let filteredComboBoxList = { ...comboBoxList };

    // 年金
    // 加入状況が「有」の場合、保険種類の選択項目が「厚生年金」となっていること
    let pensionTypeComboBoxList = _.cloneDeep(comboBoxList.pensionType);
    if (insuranceInfo.pension_flag === EXISTANCE_EXCLUSION_FLAG.EXIST.ID) {
      pensionTypeComboBoxList = filterComboBoxPensionTypeWhenExist(
        pensionTypeComboBoxList
      );
    }
    // 「適用除外」の場合
    if (insuranceInfo.pension_flag === EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID) {
      // 年齢対象(20歳-60歳)もしくは任意加入が「加入」に設定されてる場合、保険種類の選択項目が「国民年金」となっていること
      if (
        // 年齢対象
        (isDayBeforeXYearsOld(this.props.workerBirthday, 20) &&
          !isDayBeforeXYearsOld(this.props.workerBirthday, 60)) ||
        // 「任意加入」が表示されてること、そして「加入」に設定されてること
        // BLDE_V2-47685 既存データで「加入」に設定されてる場合もあるため、「加入」を反映して良い条件（任意加入項目が表示されてること）も含める
        (isShowPensionVoluntaryCoverageFlag &&
          insuranceInfo.pension_voluntary_coverage_flag ===
            PENSION_VOLUNTARY_COVERAGE_FLAG.COVERED.ID)
      ) {
        pensionTypeComboBoxList = filterComboBoxPensionTypeWhenExclusion(
          pensionTypeComboBoxList
        );
      } else {
        pensionTypeComboBoxList = [];
      }
    }
    filteredComboBoxList.pensionType = pensionTypeComboBoxList;

    this.setState({ filteredComboBoxList });
  };

  /**
   * React Component LifeCycle
   * コンポーネントがアンマウントされる時
   * */
  componentWillUnmount() {
    // アンマウントされる時にEventListenerを削除する
    EventMg.deleteEvent(EventType.FETCH_CCUS_INFO);
  }

  // 既存データに想定外のデータを読み込んだ時、ユーザーに情報修正を促すための判定
  checkExistData = insuranceInfo => {
    const healthInsuranceData = this.checkExistDataByHealthInsurance(
      insuranceInfo
    );
    const pensionData = this.checkExistDataByPension(insuranceInfo);

    const employmentData = this.checkExistDataByEmployment(insuranceInfo);
    return {
      healthInsurance: [...healthInsuranceData],
      pensionInsurance: [...pensionData],
      employmentInsurance: [...employmentData],
    };
  };

  checkExistDataByHealthInsurance = insuranceInfo => {
    const noticeData = [];
    let unusedKeys = [];
    // 加入状況 未選択
    if (isNullOrUndefinedOrEmptyStr(insuranceInfo.health_insurance_flag)) {
      unusedKeys = [
        'health_insurance_reason_exclusion',
        'health_insurance_type',
        'health_insurance_name_insurer',
        'health_insurance_expiration_date',
      ];
    }

    switch (insuranceInfo.health_insurance_flag) {
      case EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID:
        // 加入状況が無の場合
        unusedKeys = [
          'health_insurance_reason_exclusion',
          'health_insurance_type',
          'health_insurance_name_insurer',
          'health_insurance_expiration_date',
        ];
        break;
      case EXISTANCE_EXCLUSION_FLAG.EXIST.ID:
        // 加入状況が有の場合
        unusedKeys = ['health_insurance_reason_exclusion'];
        break;
      case EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID:
        // 適用除外の場合は全項目が入力し得るのでチェックなし
        break;
      default:
        break;
    }

    for (const item of unusedKeys) {
      if (!isNullOrUndefinedOrEmptyStr(insuranceInfo[item])) {
        noticeData.push(item);
      }
    }

    // 重複を排除して返す
    return [...new Set(noticeData)];
  };

  /**
   * 年金の非表示項目チェック
   */
  checkExistDataByPension = insuranceInfo => {
    const noticeData = [];

    // 加入状況 未選択
    if (isNullOrUndefinedOrEmptyStr(insuranceInfo.pension_flag)) {
      const unusedKeys = [
        'pension_reason_exclusion',
        'pension_type',
        'pension_insurance_expiration_date',
      ];

      for (const item of unusedKeys) {
        if (!isNullOrUndefinedOrEmptyStr(insuranceInfo[item])) {
          noticeData.push(item);
        }
      }
    }

    // 無
    if (insuranceInfo.pension_flag === EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID) {
      const unusedKeys = [
        'pension_reason_exclusion',
        'pension_type',
        'pension_insurance_expiration_date',
      ];
      for (const item of unusedKeys) {
        if (!isNullOrUndefinedOrEmptyStr(insuranceInfo[item])) {
          noticeData.push(item);
        }
      }
    }

    //  有
    if (insuranceInfo.pension_flag === EXISTANCE_EXCLUSION_FLAG.EXIST.ID) {
      const unusedKeys = ['pension_reason_exclusion'];
      for (const item of unusedKeys) {
        if (!isNullOrUndefinedOrEmptyStr(insuranceInfo[item])) {
          // if (item === 'pension_type') {
          //   if (insuranceInfo['pension_type'] !== '厚生年金') {
          //     noticeData.push('pension_type_exist');
          //   }
          // } else {
          noticeData.push(item);
          // }
        }
      }
    }

    // 適用除外理由
    if (insuranceInfo.pension_flag === EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID) {
      // 該当なし
      const unusedKeys = [''];
      for (const item of unusedKeys) {
        if (!isNullOrUndefinedOrEmptyStr(insuranceInfo[item])) {
          // if (item === 'pension_type') {
          //   if (insuranceInfo['pension_type'] !== '国民年金') {
          //     noticeData.push('pension_type_exclusion');
          //   }
          // } else {
          noticeData.push(item);
          // }
        }
      }
    }

    // 重複を排除する
    return [...new Set(noticeData)];
  };

  /**
   * 雇用保険の非表示項目チェック
   */
  checkExistDataByEmployment = insuranceInfo => {
    const noticeData = [];
    let unusedKeys = [];

    // 加入状況 未選択
    if (isNullOrUndefinedOrEmptyStr(insuranceInfo.employment_insurance_flag)) {
      unusedKeys = [
        'employment_insurance_reason_exclusion',
        'employment_insurance_type',
        'employment_insurance_insured_number',
      ];
    }

    switch (insuranceInfo.employment_insurance_flag) {
      case EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID:
        // 無
        unusedKeys = [
          'employment_insurance_reason_exclusion',
          'employment_insurance_type',
          'employment_insurance_insured_number',
        ];
        break;
      case EXISTANCE_EXCLUSION_FLAG.EXIST.ID:
        // 有
        unusedKeys = ['employment_insurance_reason_exclusion'];
        break;
      case EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID:
        // 適用除外
        unusedKeys = [
          'employment_insurance_type',
          'employment_insurance_insured_number',
        ];
        break;
      default:
        break;
    }

    for (const item of unusedKeys) {
      if (!isNullOrUndefinedOrEmptyStr(insuranceInfo[item])) {
        noticeData.push(item);
      }
    }

    // 重複を排除する
    return [...new Set(noticeData)];
  };

  valueNotInComboBox = (value, name, comboBoxList) => {
    const fullComboList = _.concat(comboBoxList, { [name]: '' });
    return !_.find(fullComboList, item => {
      return item[name] === value;
    });
  };

  // データ内で雇入時教育受講有無などが未設定の場合初期値設定する
  setDefaultFormValues = (key, value, insuranceInfo) => {
    const newInsuranceInfo = _.cloneDeep(insuranceInfo);
    switch (key) {
      case 'health_insurance_flag': // 健康保険 加入状況
      case 'pension_flag': // 年金保険 加入状況
      case 'employment_insurance_flag': // 雇用保険 加入状況
      case 'worker_compensation_flag': // 労災保険特別加入 加入状況
        if (isNullOrUndefinedOrEmptyStr(value)) {
          newInsuranceInfo[key] = EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID; // 「無」に設定
        }
        break;
      default:
        break;
    }
    return newInsuranceInfo;
  };

  setDefaultDropdowns = (comboBoxList, insuranceInfo) => {
    if (_.has(insuranceInfo, 'health_insurance_reason_exclusion')) {
      let target;
      switch (insuranceInfo.health_insurance_reason_exclusion) {
        case 'けんぽ適用除外承認済':
          target = _.find(comboBoxList.healthInsuranceType, item => {
            return item.health_insurance_type === '国民健康保険組合';
          });
          insuranceInfo.health_insurance_type = target.health_insurance_type;
          insuranceInfo.health_insurance_type_code =
            target.health_insurance_type_code;
          break;
        case '後期高齢者医療対象者':
          target = _.find(comboBoxList.healthInsuranceType, item => {
            return item.health_insurance_type === '後期高齢者医療制度';
          });
          insuranceInfo.health_insurance_type = target.health_insurance_type;
          insuranceInfo.health_insurance_type_code =
            target.health_insurance_type_code;
          break;
        case '生活保護受給者':
          insuranceInfo.health_insurance_type = '生活保護受給者(保険証なし)';
          insuranceInfo.health_insurance_type_code = null;
          insuranceInfo.health_insurance_name_insurer = null;
          insuranceInfo.health_insurance_expiration_date = null;
          break;
        case null:
        case '':
          if (
            this.state.insuranceInfo.health_insurance_flag ===
            EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID
          ) {
            insuranceInfo.health_insurance_type = '';
            insuranceInfo.health_insurance_type_code = null;
          }
          break;
        default:
          break;
      }
    }
    return insuranceInfo;
  };

  /**
   * 初回読み込みで既存データの処理、「その他」の設定などを行う
   * @param {object} comboBoxList 取得された健康保険、年金保険、雇用ほけんの「保険種類」データ
   * @param {object} insuranceInfo worker_insurancesから取得されたデータ
   */
  setFormItemOtherState = (comboBoxList, insuranceInfo) => {
    // 共通
    // 特段の理由
    _.each(['health_insurance', 'pension', 'employment_insurance'], value => {
      // 特段の理由が「その他」の場合、セレクトボックスに「その他」を表示、そして入力欄に内容を表示
      if (
        insuranceInfo[`${value}_special_reason`] !== null &&
        insuranceInfo[`${value}_special_reason`] !== '' &&
        !_.find(comboBoxList.specialReason, item => {
          return (
            item.special_reason === insuranceInfo[`${value}_special_reason`]
          );
        }) &&
        insuranceInfo[`${value}_special_reason`] !== 'その他'
      ) {
        insuranceInfo[`${value}_special_reason_other`] =
          insuranceInfo[`${value}_special_reason`];
        insuranceInfo[`${value}_special_reason`] = 'その他';
      }
    });

    // 適用除外理由などで選択項目が「その他」の場合は入力項目を表示・編集可能、そして入力値が選択可能な場合自動で設定する
    const setInputOrSelection = (oldInsuranceInfo, name, comboBoxList) => {
      const insuranceInfo = _.cloneDeep(oldInsuranceInfo);
      if (
        !isNullOrUndefinedOrEmptyStr(insuranceInfo[name]) &&
        this.valueNotInComboBox(insuranceInfo[name], name, comboBoxList)
      ) {
        // 初回読み込み
        if (insuranceInfo[name] !== 'その他') {
          insuranceInfo[`${name}_other`] = insuranceInfo[name];
          insuranceInfo[name] = 'その他';
        } else {
          // type_otherがselectの値になっている時はtypeに値を写して、other消す
          if (
            !this.valueNotInComboBox(
              insuranceInfo[`${name}_other`],
              name,
              comboBoxList
            ) &&
            insuranceInfo[`${name}_other`] !== ''
          ) {
            insuranceInfo[name] = insuranceInfo[`${name}_other`];
            insuranceInfo[`${name}_other`] = '';
          }
        }
      }
      return insuranceInfo;
    };

    // 健康保険 適用除外理由
    insuranceInfo = setInputOrSelection(
      insuranceInfo,
      'health_insurance_reason_exclusion',
      comboBoxList.healthInsuranceReasonExclusion
    );

    // 健康保険 保険種類
    let filterHealthInsuranceTypeComboBoxList =
      comboBoxList.healthInsuranceType;
    if (
      insuranceInfo.health_insurance_flag === EXISTANCE_EXCLUSION_FLAG.EXIST.ID
    ) {
      filterHealthInsuranceTypeComboBoxList = filterComboBoxHealthInsuranceTypeWhenExist(
        comboBoxList.healthInsuranceType
      );
    } else if (
      insuranceInfo.health_insurance_flag ===
      EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID
    ) {
      filterHealthInsuranceTypeComboBoxList = filterComboBoxHealthInsuranceTypeWhenExclusion(
        comboBoxList.healthInsuranceType,
        insuranceInfo.health_insurance_reason_exclusion
      );
    }
    let healthInsuranceTypeOptions = filterHealthInsuranceTypeComboBoxList;
    if (insuranceInfo.health_insurance_reason_exclusion === '生活保護受給者') {
      healthInsuranceTypeOptions = _.concat(
        filterHealthInsuranceTypeComboBoxList,
        { health_insurance_type: '生活保護受給者(保険証なし)' }
      );
    }

    // 保険種類が存在し、コンボボックスにない
    if (
      !isNullOrUndefinedOrEmptyStr(insuranceInfo.health_insurance_type) &&
      this.valueNotInComboBox(
        insuranceInfo.health_insurance_type,
        'health_insurance_type',
        healthInsuranceTypeOptions
      )
    ) {
      // 初回読み込み
      if (insuranceInfo.health_insurance_type !== 'その他') {
        insuranceInfo.health_insurance_type_other =
          insuranceInfo.health_insurance_type;
        insuranceInfo.health_insurance_type = 'その他';
      } else {
        // type_otherがselectの値になっている時はtypeに値を写して、other消す
        if (
          !this.valueNotInComboBox(
            insuranceInfo.health_insurance_type_other,
            'health_insurance_type',
            healthInsuranceTypeOptions
          ) &&
          insuranceInfo.health_insurance_type_other !== ''
        ) {
          insuranceInfo.health_insurance_type =
            insuranceInfo.health_insurance_type_other;
          insuranceInfo.health_insurance_type_other = '';
        }
      }
    }

    // 年金 加入状況が「有」の場合、保険種類が「厚生年金」ではない時、その他 + 自由入力となっていること
    if (insuranceInfo.pension_flag === EXISTANCE_EXCLUSION_FLAG.EXIST.ID) {
      if (
        isNullOrUndefinedOrEmptyStr(insuranceInfo.pension_type) ||
        insuranceInfo.pension_type_other === '厚生年金' ||
        insuranceInfo.pension_type === '厚生年金'
      ) {
        insuranceInfo.pension_type = '厚生年金';
        insuranceInfo.pension_type_code = '2';
        insuranceInfo.pension_type_other = '';
      } else {
        if (insuranceInfo.pension_type !== 'その他') {
          insuranceInfo.pension_type_other = insuranceInfo.pension_type;
          insuranceInfo.pension_type = 'その他';
          insuranceInfo.pension_type_code = '0';
        }
      }
    }
    // 年金 保険種類 加入状況が「適用除外」の場合
    if (insuranceInfo.pension_flag === EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID) {
      if (
        isNullOrUndefinedOrEmptyStr(insuranceInfo.pension_type) ||
        insuranceInfo.pension_type_other === '国民年金' ||
        insuranceInfo.pension_type === '国民年金'
      ) {
        // 20歳以上、60歳未満の場合
        if (
          !isDayBeforeXYearsOld(this.props.workerBirthday, 60) &&
          isDayBeforeXYearsOld(this.props.workerBirthday, 20)
        ) {
          insuranceInfo.pension_type = '国民年金';
          insuranceInfo.pension_type_code = '1';
          insuranceInfo.pension_type_other = '';
        }
        // 20歳未満、60歳以上の場合
        // 「国民年金」が選択不可能の場合で、既存データがある場合
        // 60歳以上の場合で「任意加入」が「加入」の場合「国民年金」が選択可能のため対象外
        if (
          (!isDayBeforeXYearsOld(this.props.workerBirthday, 20) ||
            isDayBeforeXYearsOld(this.props.workerBirthday, 60)) &&
          insuranceInfo.pension_type !== 'その他' &&
          !isNullOrUndefinedOrEmptyStr(insuranceInfo.pension_type) &&
          !(
            isDayBeforeXYearsOld(this.props.workerBirthday, 60) &&
            insuranceInfo.pension_voluntary_coverage_flag ===
              PENSION_VOLUNTARY_COVERAGE_FLAG.COVERED.ID
          )
        ) {
          insuranceInfo.pension_type_other = insuranceInfo.pension_type;
          insuranceInfo.pension_type = 'その他';
          insuranceInfo.pension_type_code = '0';
        }
      } else {
        if (insuranceInfo.pension_type !== 'その他') {
          insuranceInfo.pension_type_other = insuranceInfo.pension_type;
          insuranceInfo.pension_type = 'その他';
          insuranceInfo.pension_type_code = '0';
        }
      }
      // 60歳未満の場合、受給状況、任意加入のデータを利用しない
      if (
        this.props.workerBirthday &&
        !isDayBeforeXYearsOld(this.props.workerBirthday, 60)
      ) {
        insuranceInfo.pension_insurance_receiving_flag = null;
        insuranceInfo.pension_voluntary_coverage_flag = null;
      }
    }

    // 年金 適用除外理由
    insuranceInfo = setInputOrSelection(
      insuranceInfo,
      'pension_reason_exclusion',
      comboBoxList.pensionReasonExclusion
    );

    // 雇用保険 被保険者種類
    insuranceInfo = setInputOrSelection(
      insuranceInfo,
      'employment_insurance_type',
      comboBoxList.employmentInsuranceType
    );

    // 雇用保険：適用除外
    insuranceInfo = setInputOrSelection(
      insuranceInfo,
      'employment_insurance_reason_exclusion',
      comboBoxList.employmentInsuranceReasonExclusion
    );
    return insuranceInfo;
  };

  /**
   * =====================================================
   * ヘッダー周りの処理 - START
   * =====================================================
   */

  /**
   * buttonObjectを初期化する
   * @param {object} state: ステート
   * */
  clearButtonObject = state => {
    state.headerButtonObject.label = data.defaultButton.label;
    state.headerButtonObject.className = data.defaultButton.className;
    state.headerButtonObject.onClick = null;
    return state;
  };

  /**
   * 作業員一覧ページに戻るためのリンクを作成する
   * @param {object} state: ステート
   * */
  createObjectForMoveToWorkerList = state => {
    state.headerButtonObject.label = data.buttonLink.label;
    state.headerButtonObject.className = data.buttonLink.defaultClassName;
    state.headerButtonObject.onClick = this.handlerMoveToWorkerList.bind(this);
    state.header.LinkButtonObject.moveToWorkerList = _.cloneDeep(
      state.headerButtonObject
    );
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 詳細画面時ボタンを作成
   * @param {object} state: ステート
   * */
  createConfirmPageHeaderButton = state => {
    // 編集ボタン作成
    state.headerButtonObject.label = data.header.confirm.button.edit.label;
    state.headerButtonObject.className =
      data.header.confirm.button.edit.className;
    state.headerButtonObject.onClick = this.moveToWorkerEdit.bind(this);
    state.header.buttonObject.cancel = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 編集画面時ボタンを作成
   * @param {object} state: ステート
   * */
  createEditPageHeaderButton = state => {
    // 編集をやめるボタン作成
    state.headerButtonObject.label = data.header.edit.button.cancel.label;
    state.headerButtonObject.className =
      data.header.edit.button.cancel.className;
    state.headerButtonObject.onClick = this.showCancelEditDialog.bind(this);
    state.header.buttonObject.cancel = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);

    // 更新ボタン作成
    state.headerButtonObject.label = data.header.edit.button.update.label;
    state.headerButtonObject.className =
      data.header.edit.button.update.className;
    state.headerButtonObject.onClick = this.handlerUpdate.bind(this);
    state.header.buttonObject.register = _.cloneDeep(state.headerButtonObject);
    state = this.clearButtonObject(state);
    return state;
  };

  /**
   * 作業員一覧へ戻るリンクをクリックした時の処理
   * */
  handlerMoveToWorkerList = () => {
    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.showLeaveThisPageDialog();
        break;
      case WORKER_PAGE_STATUS.CONFIRM.ID:
        this.moveToWorkerList();
        break;
      default:
        break;
    }
  };

  /**
   * =====================================================
   * ヘッダー周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * 画面遷移周りの処理 - START
   * =====================================================
   */

  /**
   * 作業員一覧画面に遷移する
   */
  moveToWorkerList = () => {
    masterSlideLoader.show('Workers', { state: {} });
  };

  /**
   * 詳細画面に遷移する
   */
  moveToWorkerConfirm = () => {
    if (this.state.roanToChoseiFlg) {
      SessionStorageService.setRoanToChoseiFlg(this.state.roanToChoseiFlg);
    }
    masterSlideLoader.show('WorkerConfirm', {
      state: {
        id: `${WORKER_TAB.INSURANCE_INFO.TAB_NAME},${this.props.workerId}`,
      },
    });
  };

  /**
   * 編集画面に遷移する
   */
  moveToWorkerEdit = () => {
    if (this.state.roanToChoseiFlg) {
      SessionStorageService.setRoanToChoseiFlg(this.state.roanToChoseiFlg);
    }
    masterSlideLoader.show('WorkerEdit', {
      state: {
        id: `${WORKER_TAB.INSURANCE_INFO.TAB_NAME},${this.props.workerId}`,
      },
    });
  };

  /**
   * =====================================================
   * 画面遷移周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * ダイアログ周りの処理 - START
   * =====================================================
   */

  /**
   * ダイアログを閉じる
   * */
  closeDialog = () => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.disabled.id;
    state.informationModal.message = null;
    this.setState(state);
  };

  /**
   * 編集をやめるダイアログを表示する
   * */
  showCancelEditDialog = () => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.cancelEditDialogEnabled.id;
    this.setState(state);
  };

  /**
   * ページを移動する旨を示すダイアログを表示する
   * */
  showLeaveThisPageDialog = () => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.leaveThisPageDialogEnabled.id;
    this.setState(state);
  };

  /**
   * CCUS情報をすべて転記することに同意するかを確認するダイアログを表示する
   * */
  showCcusInfoTranscriptionAgreementDialog = () => {
    const state = _.cloneDeep(this.state);
    //CCUS事業者IDは削除された場合には、表示されない
    if (!this.props.isCcusJigyousyaDeleted) {
      state.dialogStatus =
        DIALOG_STATUS.ccusInfoTranscriptionAgreementDialogEnabled.id;

      this.setState(state);
    }
  };

  /**
   * CCUS情報をすべて転記することに同意するかを確認するダイアログを閉じる
   * */
  closeCcusInfoTranscriptionAgreementDialog = () => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.disabled.id;
    this.setState(state, () => this.setCCUSValuesInsurance());
  };

  /**
   * =====================================================
   * ダイアログ周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * API周りの処理 - START
   * =====================================================
   */

  showAskForFlagUpdateDialog = () => {
    const {
      requestUserFixListByHealthInsurance,
      requestUserFixListByPensionInsurance,
      requestUserFixListByEmploymentInsurance,
      insuranceInfo,
    } = this.state;

    let message = '';

    if (
      requestUserFixListByHealthInsurance.length > 0 &&
      isNullOrUndefinedOrEmptyStr(insuranceInfo.health_insurance_flag)
    ) {
      message += '健康保険の加入状況を設定してください。\n';
    }
    if (
      requestUserFixListByPensionInsurance.length > 0 &&
      isNullOrUndefinedOrEmptyStr(insuranceInfo.pension_flag)
    ) {
      message += '年金の加入状況を設定してください。\n';
    }
    if (
      requestUserFixListByEmploymentInsurance.length > 0 &&
      isNullOrUndefinedOrEmptyStr(insuranceInfo.employment_insurance_flag)
    ) {
      message += '雇用保険の加入状況を設定してください。\n';
    }
    message +=
      '\n未選択のままでは更新することができません。\n詳細は閉じるボタン押下後、赤枠内のメッセージをご確認ください。';
    dialogLoader.show(FormInformationDialog, {
      title: '登録情報の確認をお願いします',
      message,
      onClose: () => {
        dialogLoader.close();
      },
    });
  };

  // 想定外データの組み合わせがデータ読み込み時にあったかどうか
  hasRequestUserFixList = () => {
    if (
      this.state.requestUserFixListByHealthInsurance.length > 0 ||
      this.state.requestUserFixListByPensionInsurance.length > 0 ||
      this.state.requestUserFixListByEmploymentInsurance.length > 0
    ) {
      return true;
    }
    return false;
  };

  /**
   * 更新を実行する前に実行する処理
   * 要入力ダイアログ表示
   */
  handlerUpdate() {
    if (!this.state.userFixApproval) {
      const {
        insuranceInfo,
        requestUserFixListByHealthInsurance,
        requestUserFixListByPensionInsurance,
        requestUserFixListByEmploymentInsurance,
      } = this.state;
      if (
        (requestUserFixListByHealthInsurance.length > 0 &&
          isNullOrUndefinedOrEmptyStr(insuranceInfo.health_insurance_flag)) ||
        (requestUserFixListByPensionInsurance.length > 0 &&
          isNullOrUndefinedOrEmptyStr(insuranceInfo.pension_flag)) ||
        (requestUserFixListByEmploymentInsurance.length > 0 &&
          isNullOrUndefinedOrEmptyStr(insuranceInfo.employment_insurance_flag))
      ) {
        this.showAskForFlagUpdateDialog();
        return;
      } else {
        showUserFixApprovalDialog({
          onConfirm: () => {
            this.setState(
              {
                userFixApproval: true,
              },
              () => {
                this.handlerUpdate();
              }
            );
          },
        });
        return;
      }
    }
    if (this.hasRequestUserFixList() && !this.state.userFixApproval) {
      return;
    }

    if (this.validateAll() === false) {
      return;
    }

    const resultValidate = this.validateAllSafetyDocItem();
    // console.log('InsuranceInfo.jsx handlerUpdate 1', resultValidate);
    if (resultValidate.status === true) {
      this.updateInsuranceInfo();
      return;
    }

    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.safetyDocItemErrorDialogEnabled.id;
    state.confirmationModalSafetyDocItem.errorPropertyList = [];
    for (let key of Object.keys(resultValidate.messages)) {
      const constName = Object.values(
        SAFETY_DOC_ITEM_VALIDATE.INSURANCE_INFO
      ).find(constValue => constValue.KEY === key);
      if (!_.isUndefined(constName)) {
        state.confirmationModalSafetyDocItem.errorPropertyList.push(
          constName.TEXT
        );
      } else {
        throw new Error('InsuranceInfo.jsx handlerUpdate message property');
      }
    }

    this.setState(state);
  }

  getStateWithConvertedDate = () => {
    const state = _.cloneDeep(this.state);
    state.insuranceInfo.health_insurance_expiration_date = convertDate(
      state.insuranceInfo.health_insurance_expiration_date
    );
    state.insuranceInfo.pension_insurance_expiration_date = convertDate(
      state.insuranceInfo.pension_insurance_expiration_date
    );
    return state;
  };

  /**
   * 保険加入状況更新
   */
  updateInsuranceInfo() {
    // 多重更新防止
    if (this.updatingFlag === true) {
      return;
    }
    this.updatingFlag = true;

    const state = this.getStateWithConvertedDate();
    const cleanedUpFields = this.cleanupFieldsBeforeUpdate(
      _.cloneDeep(state.insuranceInfo)
    );

    InsuranceInfoApi.updateInsuranceInfo(
      this.props.companyId,
      this.props.workerId,
      {
        worker_insurances: cleanedUpFields,
        worker_documents: [
          ...state.attachDocuments_HealthInsurance,
          ...state.attachDocuments_Pension,
          ...state.attachDocuments_EmploymentInsurance,
          ...state.attachDocuments_UnemploymentInsurance,
          ...state.attachDocuments_WorkerCompensation,
        ],
      }
    )
      .then(response => {
        if (response.result === true) {
          this.updatingFlag = false;
          this.moveToWorkerConfirm();
          return;
        }

        state.dialogStatus = DIALOG_STATUS.updateFailedDialogEnabled.id;
        let errorMessage = extractErrorMessage(response);
        if (_.startsWith(errorMessage, 'バリデーションエラー: ')) {
          errorMessage = _.replace(errorMessage, 'バリデーションエラー: ', '');
        }
        state.informationModal.message = errorMessage;
        this.updatingFlag = false;
        this.setState({
          dialogStatus: DIALOG_STATUS.updateFailedDialogEnabled.id,
          informationModal: {
            ...state.informationModal,
            message: errorMessage,
          },
        });
      })
      .catch(error => {
        state.dialogStatus = DIALOG_STATUS.updateFailedDialogEnabled.id;
        state.informationModal.message = extractErrorMessage(error);
        this.updatingFlag = false;
        this.setState({
          dialogStatus: DIALOG_STATUS.updateFailedDialogEnabled.id,
          informationModal: {
            ...state.informationModal,
            message: extractErrorMessage(error),
          },
        });
      });
  }

  /**
   * =====================================================
   * API周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   *フォーム周りの処理 - START
   * =====================================================
   */

  /**
   * 保険加入状況の情報をセット
   * @param {string} name：セット対象のキー名
   * @param {string} value：セットするデータ
   */
  setValueInsuranceInfo = (name, value) => {
    value = deleteControlCode(value);
    let insuranceInfo = this.setInsuranceInfo(
      name,
      value,
      this.state.insuranceInfo
    );
    insuranceInfo = this.setFormItemOtherState(
      this.state.comboBoxList,
      insuranceInfo
    );
    this.setState({ insuranceInfo }, () => {
      this.validate(name);
      // 年金 保険種類が変更された場合、有効期限をチェック
      if (name === 'pension_type') {
        this.validate('pension_insurance_expiration_date');
      }
    });
  };

  /**
   * CCUS情報を転記する
   * @param {string} keyName 転記対象のキー名 指定がない場合は全項目を転記する
   * */
  setCCUSValuesInsurance(keyName) {
    // console.log('InsuranceInfo.jsx setCCUSValuesInsurance', keyName);
    const state = _.cloneDeep(this.state);
    const ccus_info = { ...this.state.ccus_info };
    if (!_.isUndefined(keyName)) {
      if (isNullOrUndefinedOrEmptyStr(ccus_info[keyName]) === false) {
        // CCUSの値がある場合は転記
        state.insuranceInfo = this.setInsuranceInfo(
          keyName,
          ccus_info[keyName],
          state.insuranceInfo
        );
      }
    } else {
      _.map(ccus_info, (val, key) => {
        if (isNullOrUndefinedOrEmptyStr(val) === false) {
          state.insuranceInfo = this.setInsuranceInfo(
            key,
            val,
            state.insuranceInfo
          );
        }
      });
    }
    this.setState(state, () => {
      if (this.validationColumns.includes(keyName)) {
        this.validate(keyName);
      }
    });
  }

  // フォームの各項目が変更された場合のアクション
  setInsuranceInfo = (name, value, sourceInsuranceInfo) => {
    const insuranceInfo = _.cloneDeep(sourceInsuranceInfo);
    insuranceInfo[name] = value;
    if (name === 'health_insurance_flag') {
      // 健康保険の加入状況が変更された場合
      switch (value) {
        case EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID:
          // 加入状況が無に変更された場合
          break;
        case EXISTANCE_EXCLUSION_FLAG.EXIST.ID:
          // 加入状況が有に変更された場合
          // 保険種類に「生活保護受給者(保険証なし)」が入力されている場合はクリアする
          if (
            insuranceInfo.health_insurance_type === '生活保護受給者(保険証なし)'
          ) {
            insuranceInfo.health_insurance_type = '';
          }
          break;
        case EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID:
          // 加入状況が適用除外に変更された場合
          // 適用除外理由が生活保護受給者の場合は保険種類を固定で「生活保護受給者(保険証なし)」
          if (
            insuranceInfo.health_insurance_reason_exclusion === '生活保護受給者'
          ) {
            insuranceInfo.health_insurance_type = '生活保護受給者(保険証なし)';
          }
          break;
        default:
          break;
      }
    }
    if (name === 'pension_flag') {
      // 年金保険の加入状況が変更された場合
      if (
        value === EXISTANCE_EXCLUSION_FLAG.EXIST.ID &&
        isNullOrUndefinedOrEmptyStr(insuranceInfo.pension_type)
      ) {
        _.assign(
          insuranceInfo,
          _.find(this.state.comboBoxList.pensionType, {
            pension_type_code: '2', // 厚生年金
          })
        );
      }
      // 加入状況が適用除外、対象の年齢の場合は「国民年金」に設定
      // 加入状況が適用除外、任意加入が「加入」の場合は「国民年金」に設定
      if (
        value === EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID &&
        isNullOrUndefinedOrEmptyStr(insuranceInfo.pension_type) &&
        ((isDayBeforeXYearsOld(this.props.workerBirthday, 20) &&
          !isDayBeforeXYearsOld(this.props.workerBirthday, 60)) ||
          insuranceInfo.pension_voluntary_coverage_flag === '1')
      ) {
        _.assign(
          insuranceInfo,
          _.find(this.state.comboBoxList.pensionType, {
            pension_type_code: '1', // 国民年金
          })
        );
      }
    }
    if (name === 'pension_voluntary_coverage_flag') {
      // 年金保険の任意加入が変更された場合
      // 未加入
      if (value === PENSION_VOLUNTARY_COVERAGE_FLAG.NOT_COVERED.ID) {
        // 保険種類を「－（国民年金の加入対象外）」に変更(null)
        insuranceInfo.pension_type = null;
        insuranceInfo.pension_type_code = '0';
        insuranceInfo.pension_type_other = '';
      }
      // 加入
      if (value === PENSION_VOLUNTARY_COVERAGE_FLAG.COVERED.ID) {
        _.assign(
          insuranceInfo,
          _.find(this.state.comboBoxList.pensionType, {
            pension_type_code: '1', // 国民年金
          })
        );
      }
    }
    // 年金保険の受給状況が変更された場合、保険種類の情報を削除
    if (name === 'pension_insurance_receiving_flag') {
      if (value === INSURANCE_RECEIVING_FLAG.UNPAID.ID) {
        insuranceInfo.pension_type = null;
        insuranceInfo.pension_type_code = '0';
        insuranceInfo.pension_type_other = '';
      }
      if (value === INSURANCE_RECEIVING_FLAG.RECEIVED.ID) {
        insuranceInfo.pension_voluntary_coverage_flag = null;
        insuranceInfo.pension_type = null;
        insuranceInfo.pension_type_code = '0';
        insuranceInfo.pension_type_other = '';
      }
    }
    if (name === 'employment_insurance_flag') {
      // 雇用保険の加入状況が変更された場合
    } else if (name === 'pension_reason_exclusion') {
      // 年金適用除外理由
      if (!_.isNil(value)) {
        insuranceInfo.pension_reason_exclusion = CcusMasterService.getPensionExclusionReason(
          value,
          this.state.comboBoxList.pensionReasonExclusion
        );
      }
    } else if (name === 'employment_insurance_reason_exclusion') {
      // 雇用保険適用除外理由
      if (!_.isNil(value)) {
        insuranceInfo.employment_insurance_reason_exclusion = CcusMasterService.getEmploymentInsExclusionReason(
          value,
          this.state.comboBoxList.employmentInsuranceReasonExclusion
        );
      }
    } else if (name === 'health_insurance_reason_exclusion') {
      // 健康保険適用除外理由
      if (!_.isNil(value)) {
        insuranceInfo.health_insurance_reason_exclusion = CcusMasterService.getHealthInsExclusionReason(
          value,
          this.state.comboBoxList.healthInsuranceReasonExclusion
        );
      }
    }

    return insuranceInfo;
  };

  /**
   *
   */
  setOneDropDown(data, name) {
    const state = _.cloneDeep(this.state);
    // BLDE_V2-32018, BLDE_V2-33282
    data = this.setDefaultDropdowns(state.comboBoxList, data);

    // 特段の理由を変更した場合、加入予定年月をnullに変更する
    switch (name) {
      case 'health_insurance_special_reason':
        if (
          this.state.insuranceInfo['health_insurance_special_reason'] ===
          data.health_insurance_special_reason
        ) {
          return;
        } else {
          data.health_insurance_expected_date_of_entry = null;
        }
        break;
      case 'pension_special_reason':
        if (
          this.state.insuranceInfo['pension_special_reason'] ===
          data.pension_special_reason
        ) {
          return;
        } else {
          data.pension_expected_date_of_entry = null;
        }
        break;
      case 'employment_insurance_special_reason':
        if (
          this.state.insuranceInfo['employment_insurance_special_reason'] ===
          data.employment_insurance_special_reason
        ) {
          return;
        } else {
          data.employment_insurance_expected_date_of_entry = null;
        }
        break;
      case 'pension_type':
        if (
          this.state.insuranceInfo.pension_flag ===
            EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID &&
          data.pension_type === '国民年金'
        ) {
          _.assign(
            data,
            _.find(this.state.comboBoxList.pensionType, {
              pension_type_code: '1', // 国民年金
            })
          );
          data.pension_type_other = '';
        }
        if (
          this.state.insuranceInfo.pension_flag ===
            EXISTANCE_EXCLUSION_FLAG.EXIST.ID &&
          data.pension_type === '厚生年金'
        ) {
          _.assign(
            data,
            _.find(this.state.comboBoxList.pensionType, {
              pension_type_code: '2', // 厚生年金
            })
          );
          data.pension_type_other = '';
        }
        break;
      default:
        break;
    }
    Object.assign(state.insuranceInfo, data);
    this.setState(state, () => {
      if (name) {
        this.validate(name);
        // 年金 保険種類が変更された場合、有効期限をチェック
        if (name === 'pension_type') {
          this.validate('pension_insurance_expiration_date');
        }
      }
    });
  }

  /**
   * TODO 要解析 ひとまずWorkerFormから移しただけ、最適化などは可能なはず
   * @description 入力値をコンボボックスから検索
   * @param {array} targetValues 該当項目の入力値
   * @param {array} comboBoxList コンボボックスリスト
   * @param {string} value 入力値
   * @param {int} index 要素数 ※コンボボックスの複数入力が行えない場合、-1をセット(保険加入状況では複数選択はないためindexが-1の場合のみ)
   * @param {object} keyParams キーパラメータ
   */
  inputValueSearch(targetValues, comboBoxList, value, index, keyParams) {
    let newTargetValue = _.cloneDeep(targetValues);
    const matchItem = _.find(
      comboBoxList,
      item => item[keyParams.searchKey] === value
    );
    newTargetValue = {
      [keyParams.codeKey]: _.isUndefined(matchItem)
        ? '0'
        : matchItem[keyParams.codeKey],
      [keyParams.searchKey]: value,
    };
    if (!_.isUndefined(keyParams.codeKeyL)) {
      newTargetValue[index] = {
        ...newTargetValue[index],
        [keyParams.codeKeyL]: _.isUndefined(matchItem)
          ? '0'
          : matchItem[keyParams.codeKeyL],
      };
    }
    this.setOneDropDown(newTargetValue, keyParams.targetKey);
  }

  /**
   * 個別バリデーション
   * @param {string} keyName
   * @return {boolean} バリデート結果
   */
  validate = keyName => {
    if (isNullOrUndefinedOrEmptyStr(keyName)) {
      throw new Error('InsuranceInfo.jsx validate');
    }
    if (!this.validationColumns.includes(keyName)) {
      return true;
      // 上記列挙した keyName 以外のものは
      // バリデート処理がないのにこの処理が呼ばれている。
      // 不要なので、returnする。
    }

    const state = _.cloneDeep(this.state);
    state.insuranceInfo.isShowPensionExpirationDate = this.state.isShowPensionExpirationDate;
    const schema = InsuranceInfoService.createValidateSchema(
      state.insuranceInfo
    );

    const result = validationByJoi(
      Joi.object().keys(schema),
      state.insuranceInfo
    );

    switch (keyName) {
      case 'health_insurance_flag':
        // 健康保険特段の理由 health_insurance_special_reason
        // 適用除外理由 employment_insurance_reason_exclusion
        // 健康保険種類 health_insurance_type
        // 健康保険名称 health_insurance_name_insurer
        state.validErrorMessage.health_insurance_special_reason = '';
        state.validErrorMessage.health_insurance_type = '';
        state.validErrorMessage.health_insurance_reason_exclusion = '';
        state.validErrorMessage.health_insurance_name_insurer = '';

        if (
          _.has(result, 'messages.health_insurance_expiration_date') &&
          result.messages.health_insurance_expiration_date !== ''
        ) {
          state.validErrorMessage.health_insurance_expiration_date =
            result.messages.health_insurance_expiration_date;
        }
        break;
      case 'pension_flag':
        if (
          _.has(result, 'messages.pension_insurance_expiration_date') &&
          result.messages.pension_insurance_expiration_date !== ''
        ) {
          state.validErrorMessage.pension_insurance_expiration_date =
            result.messages.pension_insurance_expiration_date;
        }
        if (
          _.has(result, 'messages.pension_expected_date_of_entry') &&
          result.messages.pension_expected_date_of_entry !== ''
        ) {
          state.validErrorMessage.pension_expected_date_of_entry =
            result.messages.pension_expected_date_of_entry;
        }
        break;
      case 'employment_insurance_flag':
        if (
          _.has(result, 'messages.employment_insurance_insured_number') &&
          result.messages.employment_insurance_insured_number !== ''
        ) {
          state.validErrorMessage.employment_insurance_insured_number =
            result.messages.employment_insurance_insured_number;
        }
        break;
      case 'health_insurance_reason_exclusion':
        if (
          _.has(result, 'messages.health_insurance_expiration_date') &&
          result.messages.health_insurance_expiration_date !== ''
        ) {
          state.validErrorMessage.health_insurance_expiration_date =
            result.messages.health_insurance_expiration_date;
        }
        break;
      case 'health_insurance_expiration_date':
      case 'pension_insurance_expiration_date':
      case 'employment_insurance_expiration_date':
        state.validErrorMessage[keyName] = _.isUndefined(
          result.messages[keyName]
        )
          ? ''
          : result.messages[keyName];
        break;
      case 'health_insurance_special_reason':
        if (
          _.has(
            state.validErrorMessage,
            'health_insurance_expected_date_of_entry'
          )
        ) {
          state.validErrorMessage['health_insurance_expected_date_of_entry'] =
            '';
        }
        break;
      case 'pension_special_reason':
        if (_.has(state.validErrorMessage, 'pension_expected_date_of_entry')) {
          state.validErrorMessage['pension_expected_date_of_entry'] = '';
        }
        break;
      case 'employment_insurance_special_reason':
        if (
          _.has(
            state.validErrorMessage,
            'employment_insurance_expected_date_of_entry'
          )
        ) {
          state.validErrorMessage[
            'employment_insurance_expected_date_of_entry'
          ] = '';
        }
        break;
      case 'health_insurance_expected_date_of_entry':
      case 'pension_expected_date_of_entry':
      case 'employment_insurance_expected_date_of_entry':
        state.validErrorMessage[keyName] = _.isUndefined(
          result.messages[keyName]
        )
          ? ''
          : result.messages[keyName];
        break;
      case 'employment_insurance_insured_number':
        state.validErrorMessage.employment_insurance_insured_number = _.isUndefined(
          result.messages.employment_insurance_insured_number
        )
          ? ''
          : messageUtility.getMessage('E-000-042');
        break;
      case 'const_number':
        state.validErrorMessage.const_number = _.isUndefined(
          result.messages.const_number
        )
          ? ''
          : messageUtility.getMessage('E-000-042');
        break;
      case 'enterprise_agreement_number':
        state.validErrorMessage.enterprise_agreement_number = _.isUndefined(
          result.messages.enterprise_agreement_number
        )
          ? ''
          : messageUtility.getMessage('E-000-042');
        break;
      case 'enterprise_insured_number':
        state.validErrorMessage.enterprise_insured_number = _.isUndefined(
          result.messages.enterprise_insured_number
        )
          ? ''
          : messageUtility.getMessage('E-000-042');
        break;
      default:
        state.validErrorMessage[keyName] = _.isUndefined(
          result.messages[keyName]
        )
          ? ''
          : messageUtility.getMessage('E-000-010'); // 必須です
        break;
    }

    ['health_insurance', 'pension'].forEach(value => {
      if (
        state.insuranceInfo[`${value}_flag`] ===
        EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID
      ) {
        const reasonKey = `${value}_special_reason`;
        let reasonValidate = state.insuranceInfo[reasonKey];
        if (reasonValidate === 'その他') {
          reasonValidate = state.insuranceInfo[`${reasonKey}_other`];
        }

        const isInvalidReason =
          reasonValidate === specialReasonComboBoxList[0].special_reason; //現場入場時点で６０歳以上で厚生年金保険に未加入
        if (_.includes(keyName, reasonKey) || keyName === `${value}_flag`) {
          state.validErrorMessage[reasonKey] = isInvalidReason
            ? messageUtility.getMessage('E-000-071')
            : '';
        }
        if (isInvalidReason && state.validErrorMessage[reasonKey]) {
          result.status = false;
        }
      }
    });

    if (result.status) {
      state.validErrorMessage = _.pick(state.validErrorMessage, [
        'attachDocuments_HealthInsurance',
        'attachDocuments_Pension',
        'attachDocuments_EmploymentInsurance',
        'attachDocuments_UnemploymentInsurance',
        'attachDocuments_WorkerCompensation'
      ]);

      result.status = _.isEmpty(state.validErrorMessage);
    }
    this.setState({
      validErrorMessage: state.validErrorMessage,
    });
    return result.status;
  };

  // TODO
  validateFile = (document, attachDocuments) => {
    return true;
    // const schema = _.pick(
    //   InsuranceInfoService.createValidateSchema(),
    //   attachDocuments
    // );

    // const result = validationByJoi(Joi.object().keys(schema), document);
    // return result.status;
  };

  /**
   * 全体バリデーション
   * @return {boolean} バリデート結果
   *  validateAll の前に onBlur で validate が必ず実行されるために
   *  メッセージ表示処理はいらないような気もするが念の為実装する
   */
  validateAll = () => {
    const stateValue = _.cloneDeep(this.state);
    stateValue.insuranceInfo.isShowPensionExpirationDate = this.state.isShowPensionExpirationDate;
    const schema = InsuranceInfoService.createValidateSchema(
      stateValue.insuranceInfo
    );

    stateValue.insuranceInfo = this.cleanupFieldsBeforeUpdate(
      stateValue.insuranceInfo
    );

    const validateTarget = {
      ...stateValue.insuranceInfo,
    };

    const result = validationByJoi(Joi.object().keys(schema), validateTarget);

    if (result.messages) {
      const skipArray = [
        'employment_insurance_insured_number',
        'const_number',
        'enterprise_agreement_number',
        'enterprise_insured_number',
        'health_insurance_expiration_date',
        'pension_insurance_expiration_date',
        'attachDocuments_HealthInsurance',
        'attachDocuments_Pension',
        'attachDocuments_EmploymentInsurance',
        'attachDocuments_UnemploymentInsurance',
        'attachDocuments_WorkerCompensation',
      ];
      for (const item in result.messages) {
        if (!skipArray.includes(item)) {
          stateValue.validErrorMessage[item] = _.isUndefined(
            result.messages[item]
          )
            ? ''
            : '必須です';
        }
      }
    }

    stateValue.validErrorMessage.employment_insurance_insured_number = _.isUndefined(
      result.messages.employment_insurance_insured_number
    )
      ? ''
      : messageUtility.getMessage('E-000-042');
    stateValue.validErrorMessage.const_number = _.isUndefined(
      result.messages.const_number
    )
      ? ''
      : messageUtility.getMessage('E-000-042');
    stateValue.validErrorMessage.enterprise_agreement_number = _.isUndefined(
      result.messages.enterprise_agreement_number
    )
      ? ''
      : messageUtility.getMessage('E-000-042');
    stateValue.validErrorMessage.enterprise_insured_number = _.isUndefined(
      result.messages.enterprise_insured_number
    )
      ? ''
      : messageUtility.getMessage('E-000-042');
    stateValue.validErrorMessage.health_insurance_expiration_date = _.isUndefined(
      result.messages.health_insurance_expiration_date
    )
      ? ''
      : result.messages.health_insurance_expiration_date;
    stateValue.validErrorMessage.pension_insurance_expiration_date = _.isUndefined(
      result.messages.pension_insurance_expiration_date
    )
      ? ''
      : result.messages.pension_insurance_expiration_date;

    // 添付ファイルエラー処理
    if (!attachDocumentFilesCheck(stateValue.attachDocuments_HealthInsurance)) {
      stateValue.validErrorMessage.attachDocuments_HealthInsurance =
        '添付ファイルエラー';
    }
    stateValue.validErrorMessage.attachDocuments_Pension = attachDocumentFilesCheck(
      stateValue.attachDocuments_Pension
    )
      ? ''
      : '添付ファイルエラー';
    stateValue.validErrorMessage.attachDocuments_EmploymentInsurance = attachDocumentFilesCheck(
      stateValue.attachDocuments_EmploymentInsurance
    )
      ? ''
      : '添付ファイルエラー';
    stateValue.validErrorMessage.attachDocuments_UnemploymentInsurance = attachDocumentFilesCheck(
      stateValue.attachDocuments_UnemploymentInsurance
    )
      ? ''
      : '添付ファイルエラー';
    stateValue.validErrorMessage.attachDocuments_WorkerCompensation = attachDocumentFilesCheck(
      stateValue.attachDocuments_WorkerCompensation
    )
      ? ''
      : '添付ファイルエラー';
    stateValue.validErrorMessage.health_insurance_special_reason = _.isEqual(
      validateTarget.health_insurance_special_reason,
      specialReasonComboBoxList[0].special_reason
    )
      ? messageUtility.getMessage('E-000-071')
      : '';

    stateValue.validErrorMessage.pension_special_reason = _.isEqual(
      validateTarget.pension_special_reason,
      specialReasonComboBoxList[0].special_reason
    )
      ? messageUtility.getMessage('E-000-071')
      : '';

    this.setState({
      validErrorMessage: stateValue.validErrorMessage,
    });

    return (
      Object.values(stateValue.validErrorMessage).filter(v => v !== '')
        .length === 0
    );
  };

  /**
   * 既存データの更新の前に不要なデータがあれば削除する
   * (メモ: 画面で値が変更されたときは setValueInsuranceInfo にて同様のクリア処理を行っている)
   */
  cleanupFieldsBeforeUpdate(insuranceInfo) {
    // 共通 加入予定年月が空白の場合nullに設定する
    _.each(
      [
        'health_insurance_expected_date_of_entry',
        'pension_expected_date_of_entry',
        'employment_insurance_expected_date_of_entry',
      ],
      value => {
        if (insuranceInfo[value] === '/') {
          insuranceInfo[value] = null;
        }
      }
    );
    // 健康保険 適用除外理由
    if (
      insuranceInfo.health_insurance_flag !==
        EXISTANCE_EXCLUSION_FLAG.EXIST.ID &&
      !_.includes(
        [
          'けんぽ適用除外承認済',
          '５人未満個人事業所',
          '常用以外の短時間労働者',
          '日雇労働者',
          '臨時労働者',
          '季節的業務',
          '巡業・興業',
          '臨時的事業',
          '個人事業主と家族従事者',
          '後期高齢者医療対象者',
          '生活保護受給者',
          'その他',
          '', // TODO: 必須条件を入れる場合外す
        ],
        insuranceInfo.health_insurance_reason_exclusion
      )
    ) {
      insuranceInfo.health_insurance_type = null; // 健康保険種類
      insuranceInfo.health_insurance_type_code = null; // 健康保険種類(コード)
      insuranceInfo.health_insurance_name_insurer = null; // 健康保険者名称
    }
    // 健康保険 適用除外理由が「生活保護受給者」の場合、保険種類以外を削除
    if (insuranceInfo.health_insurance_reason_exclusion === '生活保護受給者') {
      insuranceInfo.health_insurance_name_insurer = null; // 健康保険者名称
    }
    if (
      insuranceInfo.health_insurance_flag !==
      EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID
    ) {
      insuranceInfo.health_insurance_reason_exclusion = null; // 適用除外理由
    }

    // 年金
    if (insuranceInfo.pension_flag !== EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID) {
      insuranceInfo.pension_reason_exclusion = null; // 適用除外理由
    }
    // 60歳未満の場合、「受給状況」・pension_voluntary_coverage_flagがnullになる
    if (!isDayBeforeXYearsOld(this.props.workerBirthday, 60)) {
      insuranceInfo.pension_insurance_receiving_flag = null;
      insuranceInfo.pension_voluntary_coverage_flag = null;
    }
    // 保険種類が「国民年金」の場合、そして保険種類プルダウンから「国民年金」が選択可能な場合、正しい保険種類コードに設定する
    // BLDE_V2-47761のバグで「国民年金」なのに保険種類コードが異なる既存データがある可能性があるため
    if (
      insuranceInfo.pension_type === '国民年金' &&
      _.some(this.state.filteredComboBoxList.pensionType, {
        pension_type: '国民年金',
      })
    ) {
      const pensionType = this.state.filteredComboBoxList.pensionType.find(
        type => type.pension_type === '国民年金'
      );
      insuranceInfo.pension_type_code = pensionType.pension_type_code;
    }
    // 雇用保険
    if (
      insuranceInfo.employment_insurance_flag !==
      EXISTANCE_EXCLUSION_FLAG.EXIST.ID
    ) {
      insuranceInfo.employment_insurance_type = null; // 被保険者種類名称
      insuranceInfo.employment_insurance_type_code = null; // 被保険者種類名称(コード)
      insuranceInfo.employment_insurance_insured_number = null; // 被保険者番号
    }
    if (
      insuranceInfo.employment_insurance_flag !==
      EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID
    ) {
      insuranceInfo.employment_insurance_reason_exclusion = null; // 適用除外理由
    }

    insuranceInfo = this.cleanUpOtherFields(insuranceInfo); // 「その他」データ
    insuranceInfo = this.cleanUpFieldsByFlag(insuranceInfo);
    return insuranceInfo;
  }

  // 「その他」データをAPI用に正しいプロパティ名に変更する
  cleanUpOtherFields = insuranceInfo => {
    const otherFields = [
      'health_insurance_special_reason',
      'health_insurance_reason_exclusion',
      'health_insurance_type',
      'pension_special_reason',
      'pension_reason_exclusion',
      'pension_type',
      'employment_insurance_special_reason',
      'employment_insurance_reason_exclusion',
      'employment_insurance_type',
    ];
    _.each(otherFields, value => {
      if (insuranceInfo[value] === 'その他') {
        const value_other = insuranceInfo[`${value}_other`];
        if (value_other) {
          insuranceInfo[value] = insuranceInfo[`${value}_other`];
        } else {
          insuranceInfo[value] = '';
        }
      }
      if (_.has(insuranceInfo, `${value}_other`)) {
        insuranceInfo = _.omit(insuranceInfo, `${value}_other`);
      }
    });
    return insuranceInfo;
  };

  cleanUpFieldsByFlag = insuranceInfo => {
    switch (insuranceInfo.health_insurance_flag) {
      case '':
      case null:
        insuranceInfo.health_insurance_special_reason = null;
        insuranceInfo.health_insurance_special_reason_other = null;
        insuranceInfo.health_insurance_expected_date_of_entry = null;
        insuranceInfo.health_insurance_reason_exclusion = null;
        insuranceInfo.health_insurance_reason_exclusion_other = null;
        insuranceInfo.ccus_health_insurance_reason_exclusion_code = null;
        insuranceInfo.health_insurance_type = null;
        insuranceInfo.health_insurance_type_code = null;
        insuranceInfo.health_insurance_name_insurer = null;
        insuranceInfo.health_insurance_expiration_date = null;
        break;
      case EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID:
        insuranceInfo.health_insurance_reason_exclusion = null;
        insuranceInfo.health_insurance_reason_exclusion_other = null;
        insuranceInfo.ccus_health_insurance_reason_exclusion_code = null;
        insuranceInfo.health_insurance_type = null;
        insuranceInfo.health_insurance_type_code = null;
        insuranceInfo.health_insurance_name_insurer = null;
        insuranceInfo.health_insurance_expiration_date = null;
        break;
      case EXISTANCE_EXCLUSION_FLAG.EXIST.ID:
        insuranceInfo.health_insurance_special_reason = null;
        insuranceInfo.health_insurance_special_reason_other = null;
        insuranceInfo.health_insurance_expected_date_of_entry = null;
        insuranceInfo.health_insurance_reason_exclusion = null;
        insuranceInfo.health_insurance_reason_exclusion_other = null;
        insuranceInfo.ccus_health_insurance_reason_exclusion_code = null;
        break;
      case EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID:
        insuranceInfo.health_insurance_special_reason = null;
        insuranceInfo.health_insurance_special_reason_other = null;
        insuranceInfo.health_insurance_expected_date_of_entry = null;
        if (
          insuranceInfo.ccus_health_insurance_reason_exclusion_code === '011'
        ) {
          // 生活保護受給者の場合、「保険者名」「有効期限」をnullに設定
          insuranceInfo.health_insurance_name_insurer = null;
          insuranceInfo.health_insurance_expiration_date = null;
        }
        break;
      default:
        break;
    }

    switch (insuranceInfo.pension_flag) {
      case '':
      case null:
        insuranceInfo.pension_special_reason = null;
        insuranceInfo.pension_special_reason_other = null;
        insuranceInfo.pension_expected_date_of_entry = null;
        insuranceInfo.pension_reason_exclusion = null;
        insuranceInfo.ccus_pension_reason_exclusion_code = null;
        insuranceInfo.pension_reason_exclusion_other = null;
        insuranceInfo.pension_type = null;
        insuranceInfo.pension_type_code = null;
        insuranceInfo.pension_type_other = null;
        insuranceInfo.pension_ins_biz_name = null;
        insuranceInfo.pension_insurance_expiration_date = null;
        break;
      case EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID:
        insuranceInfo.pension_reason_exclusion = null;
        insuranceInfo.ccus_pension_reason_exclusion_code = null;
        insuranceInfo.pension_reason_exclusion_other = null;
        insuranceInfo.pension_type = null;
        insuranceInfo.pension_type_code = null;
        insuranceInfo.pension_type_other = null;
        insuranceInfo.pension_ins_biz_name = null;
        insuranceInfo.pension_insurance_expiration_date = null;
        break;
      case EXISTANCE_EXCLUSION_FLAG.EXIST.ID:
        insuranceInfo.pension_special_reason = null;
        insuranceInfo.pension_special_reason_other = null;
        insuranceInfo.pension_expected_date_of_entry = null;
        insuranceInfo.pension_reason_exclusion = null;
        insuranceInfo.ccus_pension_reason_exclusion_code = null;
        insuranceInfo.pension_reason_exclusion_other = null;
        if (!this.state.isShowPensionExpirationDate) {
          insuranceInfo.pension_insurance_expiration_date = null;
        }
        break;
      case EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID:
        insuranceInfo.pension_special_reason = null;
        insuranceInfo.pension_special_reason_other = null;
        insuranceInfo.pension_expected_date_of_entry = null;
        insuranceInfo.pension_type_other = null;
        insuranceInfo.pension_ins_biz_name = null;
        if (!this.state.isShowPensionExpirationDate) {
          insuranceInfo.pension_insurance_expiration_date = null;
        }
        if (!this.state.isShowPensionVoluntaryCoverageFlag) {
          insuranceInfo.pension_voluntary_coverage_flag = null;
        }
        break;
      default:
        break;
    }
    switch (insuranceInfo.employment_insurance_flag) {
      case '':
      case null:
        insuranceInfo.employment_insurance_special_reason = null;
        insuranceInfo.employment_insurance_special_reason_other = null;
        insuranceInfo.employment_insurance_expected_date_of_entry = null;
        insuranceInfo.employment_insurance_reason_exclusion = null;
        insuranceInfo.ccus_employment_insurance_reason_exclusion_code = null;
        insuranceInfo.employment_insurance_reason_exclusion_other = null;
        insuranceInfo.employment_insurance_type = null;
        insuranceInfo.employment_insurance_type_code = null;
        insuranceInfo.employment_insurance_type_other = null;
        insuranceInfo.employment_insurance_insured_number = null;
        break;
      case EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID:
        insuranceInfo.employment_insurance_reason_exclusion = null;
        insuranceInfo.ccus_employment_insurance_reason_exclusion_code = null;
        insuranceInfo.employment_insurance_reason_exclusion_other = null;
        insuranceInfo.employment_insurance_type = null;
        insuranceInfo.employment_insurance_type_code = null;
        insuranceInfo.employment_insurance_type_other = null;
        insuranceInfo.employment_insurance_insured_number = null;
        break;
      case EXISTANCE_EXCLUSION_FLAG.EXIST.ID:
        insuranceInfo.employment_insurance_special_reason = null;
        insuranceInfo.employment_insurance_special_reason_other = null;
        insuranceInfo.employment_insurance_expected_date_of_entry = null;
        insuranceInfo.employment_insurance_reason_exclusion = null;
        insuranceInfo.ccus_employment_insurance_reason_exclusion_code = null;
        insuranceInfo.employment_insurance_reason_exclusion_other = null;
        break;
      case EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID:
        insuranceInfo.employment_insurance_special_reason = null;
        insuranceInfo.employment_insurance_special_reason_other = null;
        insuranceInfo.employment_insurance_expected_date_of_entry = null;
        insuranceInfo.employment_insurance_type = null;
        insuranceInfo.employment_insurance_type_code = null;
        insuranceInfo.employment_insurance_type_other = null;
        insuranceInfo.employment_insurance_insured_number = null;
        break;
      default:
        break;
    }

    return insuranceInfo;
  };

  /**
   * 安全書類項目用バリデーション(要入力)
   */
  validateAllSafetyDocItem = () => {
    let insuranceInfo = _.cloneDeep(this.state.insuranceInfo);
    insuranceInfo.workerBirthday = this.props.workerBirthday;
    insuranceInfo = this.cleanUpOtherFields(insuranceInfo);
    const schema = InsuranceInfoService.createValidateSchemaSafetyDocItem(
      insuranceInfo
    );

    const result = validationByJoi(Joi.object().keys(schema), insuranceInfo);

    if (!_.isObject(result.messages)) {
      throw new Error('InsuranceInfo.jsx validateAllSafetyDocItem');
    }
    return result;
  };

  /**
   * =====================================================
   * フォーム周りの処理 - END
   * =====================================================
   */

  /**
   * LargeType からプロパティ名を取得する関数
   */
  largetypeStateAttachDocumentsPropName(typeL) {
    switch (typeL) {
      case ATTACH_DOCUMENT_TYPE_WORKER.HEALTH_INSURANCE:
        return 'attachDocuments_HealthInsurance';
      case ATTACH_DOCUMENT_TYPE_WORKER.PENSION_INSURANCE:
        return 'attachDocuments_Pension';
      case ATTACH_DOCUMENT_TYPE_WORKER.EMPLOYMENT_INSURANCE:
        return 'attachDocuments_EmploymentInsurance';
      case ATTACH_DOCUMENT_TYPE_WORKER.RETIREMENT_MUTUAL_AID:
        return 'attachDocuments_UnemploymentInsurance';
      case ATTACH_DOCUMENT_TYPE_WORKER.LABOR_ACCIDENT_INSURANCE_SPECIAL_ENROLLMENT:
        return 'attachDocuments_WorkerCompensation';
      default:
        throw new Error(`largetypeStateAttachDocumentsPropName typeL:${typeL}`);
    }
  }

  /**
   * 添付ファイルのサイズ・タイプ・ファイル名が存在するかをチェックする処理
   */
  filesCheck = (documents) => {
    let validFile = true;
    _.forEach(documents, document => {
      let result = (_.get(document, 'invalidSize', false) || _.get(document, 'invalidType', false) || _.get(document, 'invalidName', false));
      if (result) {
        validFile = false;
      }
    })
    return validFile;
  };

  /**
   * 添付書類 ファイル選択処理
   */
  uploadFile = async (file, typeL, typeS) => {
    const stateNameDocuments = this.largetypeStateAttachDocumentsPropName(
      typeL
    );
    attachDocumentWorkerUploadState(
      this.state[stateNameDocuments],
      documents => {
        const validateResult = this.filesCheck(documents);
        if (validateResult) {
          this.setState({ [stateNameDocuments]: documents });
        } else {
          this.setState({
            [stateNameDocuments]: documents,
            validErrorMessage: {
              ...this.state.validErrorMessage,
              [stateNameDocuments]: '添付ファイルエラー',
            }
          });
        }
      },
      this.props.companyId,
      this.props.workerId,
      file,
      typeL,
      typeS
    );
  };

  /**
   * 添付書類 ファイルダウンロード処理
   */
  async download(fileId) {
    attachDocumentWorkerDownload(
      () => {
        this.setState({
          dialogStatus: DIALOG_STATUS.attachFileNotExistDialogEnagled.id,
        });
      },
      this.props.companyId,
      this.props.workerId,
      fileId
    );
  }

  /**
   * 添付書類 ファイル登録削除処理
   */
  deleteFile = file => {
    const stateNameDocuments = this.largetypeStateAttachDocumentsPropName(
      file.file_typeL
    );
    attachDocumentDeleteState(
      this.state[stateNameDocuments],
      documents => {
        const validateResult = this.filesCheck(documents);
        if (validateResult) {
          this.setState({ 
            [stateNameDocuments]: documents,
            validErrorMessage: {
              ...this.state.validErrorMessage,
              [stateNameDocuments]: '',
            }
          });
        } else {
          this.setState({
            [stateNameDocuments]: documents,
            validErrorMessage: {
              ...this.state.validErrorMessage,
              [stateNameDocuments]: '添付ファイルエラー',
            }
          });
        }
      },
      file
    );
  };

  setVisibleDownloadErrorDialog = value => {
    this.setState({ visibleDownloadErrorDialog: value });
  };

  downloadWorkerInsuranceManual = () => {
    const fileCode = WORKER_INSURANCE_MANUAL.fileCode;
    const fileName = WORKER_INSURANCE_MANUAL.fileName;
    const params = { file_code: fileCode };
    PrintUtility.printOrOpenBlob(
      async () => {
        return StaticFileService.files(params).then(response => {
          if (_.includes(response.type, 'octet-stream')) {
            const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
            return new Blob([bom, response], { type: 'application/pdf' });
          } else {
            this.setVisibleDownloadErrorDialog(true);
            return null;
          }
        });
      },
      fileName,
      FILE_CODE.PDF,
      false
    );
  };

  /**
   * CCUSから情報を取得するボタン・補足説明の表示
   */
  showFetchCcusDescription = () => {
    const REACT_APP_ZENDESK_URL = ENV_VARS.REACT_APP_ZENDESK_URL;
    if (this.props.pageStatus.ID === WORKER_PAGE_STATUS.EDIT.ID) {
      if (this.props.isAgencyRegister) {
        if (!_.has(this.props.agencyInfo, 'in_upstream_ccus_field_trees')) {
          return;
        } else {
          // 代行先の作業員
          const canFetchCcus =
            this.props.isAlreadyCcusConnect &&
            this.props.agencyInfo.in_upstream_ccus_field_trees &&
            this.props.isLinkedUser;
          // BLDE_V2-50226 CCUS事業者IDは削除された場合にも表示されない
          if (canFetchCcus && !this.props.isCcusJigyousyaDeleted) {
            if (isNullOrUndefinedOrEmptyStr(this.props.linkedToCcusDate)) {
              return (
                <FetchCcusDescription
                  description={messageUtility.getMessage('I-000-161')}
                  onClick={() => this.props.callFetchCcusWorkersData()}
                />
              );
            } else {
              return (
                <FetchCcusDescription
                  description={messageUtility.getMessage('I-000-162')}
                  linkedToCcusDate={this.props.linkedToCcusDate}
                  onClick={() => this.props.callFetchCcusWorkersData()}
                />
              );
            }
          } else {
            return (
              // 代行先のCCUSに登録された詳細情報はCCUSの制限により取得できません。<br>Buildeeに直接入力を行ってください。
              // BLDE_V2-50226  CCUS事業者IDは削除されたなら、「代行先のCCUS連携情報が登録されている」の文言は赤色になる。
              <FetchCcusDescription
                description={
                  <span>
                    CCUSから情報を取得することができません。赤字の条件が満たされていません。
                    <br />
                    CCUSから代行先の情報を取得するには、下記の条件をすべて満たす必要があります。
                    <br />
                    <br />
                    <ul className='fetch-ccus-description-message__text-list'>
                      {/* BLDE_V2-50623 代行先会社はCCUSと連携されているかどうかによって文言の色は変更する */}
                      <li
                        className={
                          this.props.isCcusJigyousyaConnected &&
                          this.props.isAlreadyCcusConnect &&
                          !this.props.isCcusJigyousyaDeleted
                            ? ''
                            : 'text--negative'
                        }
                      >
                        <span className='fetch-ccus-description-message__text'>
                          {messageUtility.getMessage('I-000-263')}
                        </span>
                      </li>
                      <li
                        className={
                          this.props.isLinkedUser ? '' : 'text--negative'
                        }
                      >
                        <span className='fetch-ccus-description-message__text'>
                          あなたのアカウントが代行先の連携ユーザーとして設定されている
                        </span>
                        {!this.props.isLinkedUser && (
                          <span>
                            （
                            <span
                              className='clickable-text'
                              onClick={() => {
                                masterSlideLoader.show('PrimeCcusPreview', {
                                  state: { id: this.props.companyId },
                                });
                              }}
                            >
                              こちら
                            </span>
                            から設定してください）
                          </span>
                        )}
                      </li>
                      <li
                        className={
                          this.props.agencyInfo.in_upstream_ccus_field_trees
                            ? ''
                            : 'text--negative'
                        }
                      >
                        <span className='fetch-ccus-description-message__text'>
                          施工体制のCCUS連携を行っているいずれかの現場で、代行先の会社があなたの会社の下位協力会社として登録されている
                        </span>
                        {!this.props.agencyInfo
                          .in_upstream_ccus_field_trees && (
                          <span>
                            （詳細は
                            <a
                              className='clickable-text'
                              href={`${getZendeskArticleUrl(
                                REACT_APP_ZENDESK_URL,
                                ZENDESK_LINK_IDS.CCUS_FIELD_TREES
                              )}`}
                              target='_blank'
                              rel='noopener noreferrer'
                            >
                              こちら
                            </a>
                            をご確認ください。）
                          </span>
                        )}
                      </li>
                    </ul>
                  </span>
                }
                disabledCcusConnectionButton
              />
            );
          }
        }
      }
      // BLDE_V2-50226 CCUS事業者IDは削除された場合、転記情報は表示されない
      if (
        (this.props.isAlreadyCcusConnect &&
          this.props.isCcusJigyousyaDeleted) ||
        !this.props.isCcusJigyousyaConnected
      ) {
        return null;
      }
      if (
        !this.props.isLinkedUser ||
        !this.props.ccusEngineerId ||
        !this.props.isAlreadyCcusConnect
      ) {
        return (
          <FetchCcusDescription
            disabledCcusConnectionButton
            description={
              <div>
                <p>
                  CCUSから情報を取得することができません。赤字の条件が満たされていません。
                </p>
                <p>
                  CCUSから情報を取得するには、下記の条件をすべて満たす必要があります。
                </p>
                <ul className='fetch-ccus-description-message__text-list'>
                  <li
                    className={!this.props.isLinkedUser ? 'text--negative' : ''}
                  >
                    <span className='fetch-ccus-description-message__text'>
                      あなたのアカウントが自社の連携ユーザーとして設定されている
                    </span>
                    {!this.props.isLinkedUser && (
                      <span>
                      （
                      <span
                        className='clickable-text'
                        onClick={() => {
                          masterSlideLoader.show('PrimeCcusPreview', {
                            state: { id: this.props.companyId },
                          });
                        }}
                      >
                        こちら
                      </span>
                        から設定してください）
                      </span>
                    )}
                  </li>
                  <li
                    className={
                      !this.props.ccusEngineerId ||
                      !this.props.isAlreadyCcusConnect
                        ? 'text--negative'
                        : ''
                    }
                  >
                    <span className='fetch-ccus-description-message__text'>
                      作業員の基本情報タブにCCUS技能者IDが登録されておりCCUS連携に成功している
                    </span>
                  </li>
                </ul>
                <br />
                <p>
                  作業員のCCUS連携の手順は
                  <a
                    className='clickable-text'
                    href={ZENDESK_URL_GUIDE.CCUS_WORKER_WARNING}
                    target='_blank'
                    rel='noreferrer noopener'
                  >
                    こちら
                  </a>
                  をご確認ください。
                </p>
              </div>
            }
          />
        );
      }
      if (isNullOrUndefinedOrEmptyStr(this.props.linkedToCcusDate)) {
        return (
          <FetchCcusDescription
            description={messageUtility.getMessage('I-000-161')}
            onClick={() => this.props.callFetchCcusWorkersData()}
          />
        );
      } else {
        return (
          <FetchCcusDescription
            description={messageUtility.getMessage('I-000-162')}
            linkedToCcusDate={this.props.linkedToCcusDate}
            onClick={() => this.props.callFetchCcusWorkersData()}
          />
        );
      }
    }
  };

  showAttentionBox = () => {
    return (
      this.hasRequestUserFixList() && (
        <div style={{ maxWidth: '960px', marginBottom: '24px' }}>
          <AttentionBox
            isInsuranceInfo={true}
            flags={this.state.initialLoadingSocialInsuranceFlag}
            healthInsuranceData={this.state.requestUserFixListByHealthInsurance}
            pensionData={this.state.requestUserFixListByPensionInsurance}
            employmentData={this.state.requestUserFixListByEmploymentInsurance}
          />
        </div>
      )
    );
  };

  // 年金保険 任意加入の表示条件チェック
  showPensionVoluntaryCoverageFlag = () => {
    const { insuranceInfo } = this.state;
    const { workerBirthday } = this.props;

    // データが取得されてない場合はreturn
    if (!insuranceInfo || !workerBirthday) {
      return;
    }

    // 表示条件 - 「加入状況：適用除外」「年齢：60歳以上」「受給状況：未受給」
    const shouldShow =
      insuranceInfo.pension_flag === EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID &&
      isDayBeforeXYearsOld(workerBirthday, 60) &&
      insuranceInfo.pension_insurance_receiving_flag ===
        INSURANCE_RECEIVING_FLAG.UNPAID.ID;

    this.setState({
      isShowPensionVoluntaryCoverageFlag: shouldShow,
    });
  };

  // 年金保険 有効期限
  // 状態が変わった場合はバリデーションする BLDE_V2-47447
  showPensionExpirationDate = () => {
    const insuranceInfo = this.state.insuranceInfo;
    const workerBirthday = this.props.workerBirthday;

    if (insuranceInfo.pension_flag === EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID) {
      this.setState(
        {
          isShowPensionExpirationDate: false,
        },
        () => {
          this.validate('pension_insurance_expiration_date');
        }
      );
    }
    if (insuranceInfo.pension_flag === EXISTANCE_EXCLUSION_FLAG.EXIST.ID) {
      this.setState(
        {
          isShowPensionExpirationDate: true,
        },
        () => {
          this.validate('pension_insurance_expiration_date');
        }
      );
    }
    if (insuranceInfo.pension_flag === EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID) {
      // 年齢が対象内の場合
      const isAgeConditionMet =
        isDayBeforeXYearsOld(workerBirthday, 20) &&
        !isDayBeforeXYearsOld(workerBirthday, 60);
      // 任意加入が加入の場合（そして任意加入が対象の場合）
      const isVoluntaryCoverage =
        insuranceInfo.pension_voluntary_coverage_flag ===
          PENSION_VOLUNTARY_COVERAGE_FLAG.COVERED.ID &&
        this.state.isShowPensionVoluntaryCoverageFlag;
      // 詳細画面の場合既存データがある場合表示
      // 編集画面の場合年齢対象、または60歳以上で任意加入が「加入」の場合のみ表示 - BLDE_V2-47679
      const isScreenConditionMet =
        (this.props.pageStatus.ID === WORKER_PAGE_STATUS.CONFIRM.ID &&
          insuranceInfo.pension_insurance_expiration_date) ||
        (this.props.pageStatus.ID === WORKER_PAGE_STATUS.EDIT.ID &&
          isDayBeforeXYearsOld(workerBirthday, 60) &&
          isVoluntaryCoverage);
      if (isScreenConditionMet) {
        this.setState({ isShowPensionExpirationDate: true }, () => {
          this.validate('pension_insurance_expiration_date');
        });
      } else {
        if (isAgeConditionMet || isVoluntaryCoverage) {
          this.setState({ isShowPensionExpirationDate: true }, () => {
            this.validate('pension_insurance_expiration_date');
          });
        } else {
          this.setState({ isShowPensionExpirationDate: false }, () => {
            this.validate('pension_insurance_expiration_date');
          });
        }
      }
    }
  };

  // 画面表示
  render() {
    return (
      <React.Fragment>
        <WorkerHeader
          LinkButtonObject={this.state.header.LinkButtonObject}
          buttonObject={this.state.header.buttonObject}
          errorMessagesCount={
            Object.values(this.state.validErrorMessage).filter(v => v !== '')
              .length
          }
        />
        <div className='contruction-detail-view__bar' />

        <InsuranceInfoForm
          ccusDescription={this.showFetchCcusDescription()} /* CCUSから情報を取得するボタン・補足説明 */
          attentionBox={this.showAttentionBox()}
          events={this.events}
          messages={this.state.validErrorMessage}
          formValues={this.state.insuranceInfo}
          ccus_info={this.state.ccus_info}
          disabledAll={this.props.pageStatus.DISABLED_ALL}
          comboBoxList={this.state.filteredComboBoxList}
          attachDocumentCodes_HealthInsurance={
            this.state.attachDocumentCodes_HealthInsurance
          }
          attachDocuments_HealthInsurance={
            this.state.attachDocuments_HealthInsurance
          }
          attachDocumentCodes_Pension={this.state.attachDocumentCodes_Pension}
          attachDocuments_Pension={this.state.attachDocuments_Pension}
          attachDocumentCodes_EmploymentInsurance={
            this.state.attachDocumentCodes_EmploymentInsurance
          }
          attachDocuments_EmploymentInsurance={
            this.state.attachDocuments_EmploymentInsurance
          }
          attachDocumentCodes_UnemploymentInsurance={
            this.state.attachDocumentCodes_UnemploymentInsurance
          }
          attachDocuments_UnemploymentInsurance={
            this.state.attachDocuments_UnemploymentInsurance
          }
          attachDocumentCodes_WorkerCompensation={
            this.state.attachDocumentCodes_WorkerCompensation
          }
          attachDocuments_WorkerCompensation={
            this.state.attachDocuments_WorkerCompensation
          }
          downloadWorkerInsuranceManual={this.downloadWorkerInsuranceManual}
          workerBirthday={this.props.workerBirthday}
          isShowPensionExpirationDate={this.state.isShowPensionExpirationDate}
          isShowPensionVoluntaryCoverageFlag={
            this.state.isShowPensionVoluntaryCoverageFlag
          }
          isCcusJigyousyaDeleted={this.props.isCcusJigyousyaDeleted} // BLDE_V2-50226 CCUS事業者IDは削除されたかどうか決断
        />

        {/* 更新失敗時のダイアログ */}
        <Information
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.updateFailedDialogEnabled.id
          }
          title={messageUtility.getMessage('E-000-005')}
          message={this.state.informationModal.message}
          buttonText={messageUtility.getMessage('I-000-008')}
          onClose={() => this.closeDialog()}
        />

        {/* 編集をやめる時のダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus === DIALOG_STATUS.cancelEditDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-025')}
          confirmButtonText={messageUtility.getMessage('I-000-025')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={messageUtility.getMessage('I-000-050')}
          isNegative
          onConfirm={() => this.moveToWorkerConfirm()}
          onCancel={() => this.closeDialog()}
        />

        {/* 作業員一覧へ戻る時のダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.leaveThisPageDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-051')}
          confirmButtonText={messageUtility.getMessage('I-000-053')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={messageUtility.getMessage('I-000-052')}
          isNegative
          onConfirm={() => this.moveToWorkerList()}
          onCancel={() => this.closeDialog()}
        />

        {/* CCUS全て転記ダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.ccusInfoTranscriptionAgreementDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-164')}
          confirmButtonText={messageUtility.getMessage('I-000-165')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={
            <React.Fragment>
              {messageUtility.getMessage('I-000-166')}
              <MoveLeftIcon className='form-list__element-ccus-icon' />
              {messageUtility.getMessage('I-000-167')}
            </React.Fragment>
          }
          isNegative
          negativeButtonClassName='btn'
          rootClassName={styles.CcusInfoTranscriptionAgreementDialog}
          onConfirm={() => this.closeCcusInfoTranscriptionAgreementDialog()}
          onCancel={() => this.closeDialog()}
        />

        {/* 安全書類項目確認のダイアログ */}
        <ConfirmationSafetyDocItemDialog
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.safetyDocItemErrorDialogEnabled.id
          }
          errorPropertyList={
            this.state.confirmationModalSafetyDocItem.errorPropertyList
          }
          onConfirm={() => {
            this.setState({ dialogStatus: DIALOG_STATUS.disabled.id }, () => {
              this.updateInsuranceInfo();
            });
          }}
          onCancel={() => {
            this.setState({ dialogStatus: DIALOG_STATUS.disabled.id });
          }}
        />

        {/* 添付ファイルが存在しないときのエラー表示 */}
        <Information
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.attachFileNotExistDialogEnagled.id
          }
          title={
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <i
                className='icon-error'
                style={{
                  fontSize: 24,
                  color: 'red',
                }}
              />
              <p>エラーが発生しました。</p>
            </div>
          }
          message={'指定されたファイルが存在しません。'}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => {
            this.setState({ dialogStatus: DIALOG_STATUS.disabled.id });
          }}
        />
        <Information
          visible={this.state.visibleDownloadErrorDialog}
          title='ダウンロードエラー'
          message={messageUtility.getMessage('E-000-033')}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.setVisibleDownloadErrorDialog(false)}
          buttonClassName='btn--sub'
        />
      </React.Fragment>
    );
  }
}

// 定数
const data = {
  buttonLink: {
    label: '作業員一覧',
    defaultClassName: 'btn-text--sm',
  },
  defaultButton: {
    label: '',
    className: 'btn',
  },
  header: {
    confirm: {
      button: {
        edit: {
          label: '編集',
          className: 'btn',
        },
      },
    },
    edit: {
      button: {
        cancel: {
          label: '編集をやめる',
          className: 'btn--sub',
        },
        update: {
          label: '更新',
          className: 'btn--effective',
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/worker/page/InsuranceInfo.jsx